/* TDA reservations v70 — unified Direct Reserve guide + All Creations reservation motion */
(() => {
  const init = (root) => {
  if (!root || root.dataset.tdaDiscoverV42Ready === 'true') return;
  root.dataset.tdaDiscoverV42Ready = 'true';

  const drawer = root.querySelector('[data-tda-discover-curtain]');
  const panel = drawer?.querySelector('.tda-discover-curtain__panel');
  const discoverView = drawer?.querySelector('[data-tda-discover-view]');
  const discoverContent = drawer?.querySelector('[data-tda-discover-content]');
  const reservationView = drawer?.querySelector('[data-tda-reservation-view]');
  const openers = root.querySelectorAll('[data-tda-discover-open]');
  const closers = drawer?.querySelectorAll('[data-tda-discover-close]') || [];
  const pricingModal = root.querySelector('.tda-pricing-modal');
  const dataNode = root.querySelector('script[type="application/json"][id^="TdaReservationData-"]');
  const activePill = root.querySelector('[data-tda-active-reservation]');
  const activePillLabel = root.querySelector('[data-tda-active-reservation-label]');
  const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (!drawer || !panel || !discoverContent || !reservationView || !dataNode) return;

  let config;
  try { config = JSON.parse(dataNode.textContent); } catch (_) { return; }

  /* Gift Card-parity leave confirmation. The markup is created here so the
     reservation experience stays shared by All Creations and product pages. */
  let leaveConfirm = drawer.querySelector('[data-tda-res-leave-confirm]');
  if (!leaveConfirm) {
    leaveConfirm = document.createElement('div');
    leaveConfirm.className = 'tda-reservation-leave-confirm';
    leaveConfirm.setAttribute('data-tda-res-leave-confirm', '');
    leaveConfirm.setAttribute('aria-hidden', 'true');
    leaveConfirm.hidden = true;

    const leaveTitleId = `TdaReservationLeaveTitle-${root.id}`;
    const leaveCopyId = `TdaReservationLeaveCopy-${root.id}`;
    leaveConfirm.innerHTML = `
      <div class="tda-reservation-leave-card" role="alertdialog" aria-modal="true" aria-labelledby="${leaveTitleId}" aria-describedby="${leaveCopyId}">
        <h3 id="${leaveTitleId}">Would you like to leave this reservation?</h3>
        <p id="${leaveCopyId}">If you leave this reservation, your selections will be lost.</p>
        <button type="button" class="tda-reservation-leave-primary" data-tda-res-leave>Leave reservation</button>
        <button type="button" class="tda-reservation-leave-continue" data-tda-res-continue><span>Continue reservation</span></button>
      </div>`;
    drawer.appendChild(leaveConfirm);
  }

  const leaveReservationButton = leaveConfirm.querySelector('[data-tda-res-leave]');
  const continueReservationButton = leaveConfirm.querySelector('[data-tda-res-continue]');

  const products = Array.isArray(config.products) ? config.products : [];
  const calendarApi = window.TDAReservationCalendar;
  let bookingCalendar = config.bookingCalendar || null;
  let calendarCheckedAt = 0;
  let calendarRenderRequest = 0;
  let calendarRefreshPromise = null;
  const refreshBookingCalendar = () => {
    if (calendarRefreshPromise) return calendarRefreshPromise;
    calendarRefreshPromise = (async () => {
    const response = await fetch('https://account.thedateatelier.co.uk/api/reservation-calendar',{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(12000)});
    if (!response.ok) throw new Error('Availability unavailable');
    const fresh = await response.json();
    if (fresh.version !== 1 || !Array.isArray(fresh.slots)) throw new Error('Invalid calendar');
    bookingCalendar = fresh;
    calendarCheckedAt = Date.now();
    })().finally(() => { calendarRefreshPromise = null; });
    return calendarRefreshPromise;
  };
  // Warm availability before the customer enters Occasion; share in-flight requests.
  if (bookingCalendar && !bookingCalendar.preview) refreshBookingCalendar().catch(() => {});
  if (bookingCalendar && !calendarApi) return;
  if (bookingCalendar?.preview) {
    const full = bookingCalendar.previewFull;
    const key = text => String(text).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    const variants = name => Object.fromEntries(products.map(product=>{
      const variant = product.variants?.find(item=>key(item.allocation) === key(name));
      return [String(product.id),{id:variant?.id,price:variant?.price || product.price}];
    }));
    bookingCalendar = {preview:true,leadDays:7,privateWeeks:24,deliveryWeekdays:[1,2,3,4,5],excludedDates:['2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29'],slots:[
      {id:'noel-2026',kind:'seasonal',title:'Noël',allocationName:'NOËL',enabled:true,capacity:30,remaining:30,deliveryFrom:'2026-12-10',deliveryUntil:'2027-01-20',variants:variants('NOËL')},
      {id:'ramadan-eid-2027',kind:'seasonal',title:'Ramadan & Eid',allocationName:'RAMADAN & EID',enabled:true,capacity:200,remaining:200,deliveryFrom:'2027-02-03',deliveryUntil:'2027-03-15',variants:variants('RAMADAN & EID')}
    ]};
    bookingCalendar.slots.push(...calendarApi.privateWeekStarts(bookingCalendar).map(start=>({id:`private-${start}`,kind:'private',title:'Private occasions',allocationName:'Private Occasion',enabled:true,capacity:10,remaining:10,weekStart:start,deliveryFrom:start,deliveryUntil:calendarApi.shift(start,6),variants:variants('Private Occasion')})));
    const fullSlot = bookingCalendar.slots.find(slot=>slot.id === full);
    if (fullSlot) fullSlot.remaining=0;
  }
  const productById = new Map(products.map(product => [String(product.id), product]));
  const storageKey = bookingCalendar ? 'tda-reservation-groups-v2' : 'tda-reservation-groups-v1';
  const activeContextKey = 'tda-active-allocation-v45';
  const currencyCode = config.currencyCode || 'GBP';
  const cartAddEndpoint = (() => {
    const raw = String(config.cartAddUrl || window.routes?.cart_add_url || '/cart/add').trim() || '/cart/add';
    return /\.js(?:[?#]|$)/.test(raw) ? raw : `${raw.replace(/\/$/, '')}.js`;
  })();

  let lastTrigger = null;
  let closeTimer = null;
  let currentProduct = null;
  let draft = null;
  const selectedSlot = () => bookingCalendar?.slots?.find(slot=>slot.id === draft?.slotId) || null;
  let currentStep = 0;
  let deliveryPicker = null;
  let deliveryCalendarOpen = false;
  let isNewAllocationRoute = false;

  const entry = reservationView.querySelector('[data-tda-res-entry]');
  const steps = reservationView.querySelector('[data-tda-res-steps]');
  const stepEls = [...reservationView.querySelectorAll('[data-tda-res-step]')];
  const progress = reservationView.querySelector('[data-tda-res-progress]');
  const visual = reservationView.querySelector('[data-tda-res-visual]');
  const visualPlaceholder = reservationView.querySelector('[data-tda-res-visual-placeholder]');
  const allocationList = reservationView.querySelector('[data-tda-res-allocation-list]');
  const weekPicker = reservationView.querySelector('[data-tda-res-week-picker]');
  const weekList = reservationView.querySelector('[data-tda-res-week-list]');
  const waitlist = reservationView.querySelector('[data-tda-res-waitlist]');
  const waitlistCopy = reservationView.querySelector('[data-tda-res-waitlist-copy]');
  const waitlistTags = reservationView.querySelector('[data-tda-res-new-waitlist-tags]');
  const step1Footer = reservationView.querySelector('[data-tda-res-step1-footer]');
  const creationsList = reservationView.querySelector('[data-tda-res-creations-list]');
  const review = reservationView.querySelector('[data-tda-res-review]');
  const errorBox = reservationView.querySelector('[data-tda-res-error]');
  const addBagButton = reservationView.querySelector('[data-tda-res-add-bag]');
  const waitlistHome = waitlist?.parentNode || null;
  const waitlistNextSibling = waitlist?.nextSibling || null;
  const step1 = reservationView.querySelector('[data-tda-res-step="1"]');
  const step1Content = step1?.querySelector('.tda-reservation-step__content');
  const step1Heading = step1Content?.querySelector(':scope > h2');
  const step1Copy = step1Content?.querySelector(':scope > .tda-reservation-step__copy');
  const step2 = reservationView.querySelector('[data-tda-res-step="2"]');
  const step2Content = step2?.querySelector('.tda-reservation-step__content');
  let privateAvailabilityView = null;
  let privateAvailabilityActive = false;
  let addMoreOpen = false;
  const giftEditor = step2?.querySelector('[data-tda-res-gift-editor]');
  const giftFooter = step2?.querySelector('[data-tda-res-gift-footer]');
  const creationFooter = step2?.querySelector('.tda-reservation-step__footer');
  const giftToggle = step2?.querySelector('[data-tda-res-gift-toggle]');
  const giftMessage = step2?.querySelector('[data-tda-res-gift-message]');
  const giftSignature = step2?.querySelector('[data-tda-res-gift-signature]');
  const giftBag = step2?.querySelector('[data-tda-res-gift-bag]');
  let giftingOpen = false;

  const syncGiftPreview = () => {
    const message = giftMessage?.value || '';
    [giftMessage, giftSignature].forEach(input => input?.closest('.tda-res-gift-field')?.classList.toggle('is-filled', !!input.value.trim()));
    const action = giftFooter?.querySelector('[data-tda-res-gift-save]');
    const hasContent = !!(message.trim() || giftSignature?.value.trim() || giftBag?.checked);
    if (action) action.textContent = hasContent ? action.dataset.continue : action.dataset.skip;
    const preview = reservationView.querySelector('[data-tda-res-gift-preview]');
    const signature = reservationView.querySelector('[data-tda-res-gift-preview-signature]');
    if (preview) preview.textContent = message.trim() || preview.dataset.placeholder;
    if (signature) signature.textContent = giftSignature?.value || '';
    reservationView.querySelector('.tda-res-gift-art__writing')?.classList.toggle('is-long',message.length > 100);
    const counter = step2?.querySelector('[data-tda-res-gift-count]');
    if (counter) counter.textContent = `${message.length}/200`;
  };
  const syncGiftChoice = () => {
    if (!giftToggle) return;
    giftToggle.setAttribute('aria-expanded',String(giftingOpen));
    const saved = step2.querySelector('[data-tda-res-gift-saved]');
    if (saved) saved.hidden = !draft?.gifting?.enabled;
  };
  const setGiftingView = (open, focus = true) => {
    if (!giftEditor || !giftFooter || !step2Content || !creationFooter) return;
    giftingOpen = open;
    step2Content.hidden = open;
    creationFooter.hidden = open;
    giftEditor.hidden = !open;
    giftFooter.hidden = !open;
    reservationView.classList.toggle('is-gifting',open);
    syncGiftChoice();

    if (focus) requestAnimationFrame(() => {
      (open ? giftEditor.querySelector('h2') : giftToggle)?.focus({preventScroll:true});
    });
  };
  const openGifting = () => {
    if (!draft || !giftEditor) return;
    const gift = draft.gifting || {};
    giftMessage.value = gift.message || '';
    giftSignature.value = gift.signature || '';
    giftBag.checked = !!gift.bag;
    giftEditor.querySelector('[data-tda-res-gift-group]').hidden = draftCount() < 2;
    syncGiftPreview();
    setGiftingView(true);
    progress.textContent = '2/3';
  };
  giftToggle?.addEventListener('click',openGifting);
  giftMessage?.addEventListener('input',syncGiftPreview);
  giftSignature?.addEventListener('input',syncGiftPreview);
  giftBag?.addEventListener('change',syncGiftPreview);


  const entryAllocation = reservationView.querySelector('[data-tda-res-entry-allocation]');
  const entryCreations = reservationView.querySelector('[data-tda-res-entry-creations]');
  const entryReview = reservationView.querySelector('[data-tda-res-entry-review]');
  const entryRows = [...reservationView.querySelectorAll('[data-tda-res-entry-open]')];
  if (bookingCalendar) {
    const occasionLabel = entryAllocation?.parentElement.querySelector('strong');
    if (occasionLabel) occasionLabel.textContent = 'Selection';
  }
  const entryThumbs = new Map(
    entryRows.map(row => [
      Number(row.dataset.tdaResEntryOpen || 0),
      row.querySelector('.tda-reservation-entry__thumb')
    ])
  );

  const slugify = (value) => (value || '')
    .toString().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0,70);

  const formatMoney = (minorUnits) => {
    const value = Number(minorUnits || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: currencyCode || 'GBP', minimumFractionDigits: 2
      }).format(value);
    } catch (_) { return `£${value.toFixed(2)}`; }
  };

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#039;');


  const injectReservationBagLoadingStyles = () => {
    const styleId = `tda-res-bag-loading-${root.id}`;
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #${root.id} .tda-res-bag-action {
        position: relative;
        overflow: hidden;
        text-transform: none !important;
      }
      #${root.id} .tda-res-bag-action .tda-res-bag-copy {
        display: inline-block;
        transition: opacity 180ms ease, transform 220ms ease;
      }
      #${root.id} .tda-res-bag-action .tda-res-bag-arch-wrap {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 34px;
        height: 34px;
        display: grid;
        place-items: center;
        opacity: 0;
        transform: translate(-50%, -50%) scale(.90);
        pointer-events: none;
        transition: opacity 150ms ease, transform 180ms ease;
      }
      #${root.id} .tda-res-bag-action .tda-res-bag-arch {
        display: block;
        width: 17px;
        height: 23px;
        box-sizing: border-box;
        border: 2px solid #fff;
        border-bottom: 0;
        border-radius: 11px 11px 0 0;
        transform: rotate(0deg);
        transform-origin: 50% 50%;
      }
      #${root.id} .tda-res-bag-action.is-loading,
      #${root.id} .tda-res-bag-action.is-loading:hover,
      #${root.id} .tda-res-bag-action.is-loading:focus-visible {
        cursor: wait !important;
        opacity: 1 !important;
        background: var(--tda-accent, #947239) !important;
        border-color: var(--tda-accent, #947239) !important;
        color: #fff !important;
        transform: none !important;
        box-shadow: none !important;
      }
      #${root.id} .tda-res-bag-action.is-loading .tda-res-bag-copy {
        opacity: 0;
        transform: translateY(2px);
      }
      #${root.id} .tda-res-bag-action.is-loading .tda-res-bag-arch-wrap {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      #${root.id} .tda-res-bag-action.is-turning .tda-res-bag-arch-wrap {
        animation: tdaResAtelierTurn 920ms cubic-bezier(.55,.12,.35,.98) 1 both;
        transform-origin: 50% 50%;
      }
      @keyframes tdaResAtelierTurn {
        0%   { transform: translate(-50%, -50%) scale(1) rotate(0deg); }
        100% { transform: translate(-50%, -50%) scale(1) rotate(360deg); }
      }
      @media (prefers-reduced-motion: reduce) {
        #${root.id} .tda-res-bag-action.is-turning .tda-res-bag-arch-wrap { animation: none !important; }
      }
    `;
    document.head.appendChild(style);
  };

  const prepareBagButton = (button = addBagButton) => {
    if (!button) return;
    button.classList.add('tda-res-bag-action');
    if (button.dataset.tdaBagPrepared === 'true') return;
    const label = button.textContent.trim() || 'Add to bag';
    button.textContent = '';
    const labelSpan = document.createElement('span');
    labelSpan.className = 'tda-res-bag-copy';
    labelSpan.textContent = label;
    const archWrap = document.createElement('span');
    archWrap.className = 'tda-res-bag-arch-wrap';
    archWrap.setAttribute('aria-hidden', 'true');
    const arch = document.createElement('span');
    arch.className = 'tda-res-bag-arch';
    archWrap.appendChild(arch);
    button.append(labelSpan, archWrap);
    button.dataset.tdaBagPrepared = 'true';
  };

  const setBagButtonLabel = (label, button = addBagButton) => {
    if (!button) return;
    prepareBagButton(button);
    const labelSpan = button.querySelector('.tda-res-bag-copy');
    if (labelSpan) labelSpan.textContent = label;
  };

  const injectGiftCardMicroStyles = () => {
    const styleId = `tda-res-micro-${root.id}`;
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #${root.id} .tda-reservation-allocation-list { overflow: visible; }
      #${root.id} .tda-res-allocation-option {
        transition: border-color .28s ease, background-color .28s ease, transform .28s ease;
      }
      #${root.id} .tda-res-allocation-option.is-selected {
        border-color: #6F6C67 !important;
        background: #FAFAF9 !important;
      }
            #${root.id} .tda-res-allocation-option-wrap {
        display: grid;
        gap: 0;
      }
      #${root.id} .tda-res-allocation-next {
        appearance: none;
        width: calc(100% - 28px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        margin: 0 14px;
        padding: 8px 1px 6px;
        border: 0;
        background: transparent;
        color: rgba(34,33,31,.66);
        font: 400 9.7px/1.35 "Helvetica Neue", Helvetica, Arial, sans-serif;
        letter-spacing: .03em;
        text-align: left;
        cursor: pointer;
        transition: color .34s ease;
      }
      #${root.id} .tda-res-allocation-next:hover,
      #${root.id} .tda-res-allocation-next:focus-visible,
      #${root.id} .tda-res-allocation-next.is-open {
        color: var(--tda-accent, #947239);
        outline: none;
      }
      #${root.id} .tda-res-allocation-next__symbol {
        position: relative;
        flex: 0 0 16px;
        width: 16px;
        height: 16px;
        color: currentColor;
      }
      #${root.id} .tda-res-allocation-next__symbol::before,
      #${root.id} .tda-res-allocation-next__symbol::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 9px;
        height: 1px;
        background: currentColor;
        transform: translate(-50%,-50%);
        transform-origin: center;
        transition: transform .58s cubic-bezier(.77,0,.175,1), opacity .3s ease;
      }
      #${root.id} .tda-res-allocation-next__symbol::after {
        transform: translate(-50%,-50%) rotate(90deg);
      }
      #${root.id} .tda-res-allocation-next[aria-expanded="true"] .tda-res-allocation-next__symbol::after {
        transform: translate(-50%,-50%) rotate(0deg);
      }
#${root.id} .tda-res-inline-drawer {
        display: grid;
        grid-template-rows: 0fr;
        clip-path: inset(0 0 100% 0);
        transform: translateY(-5px);
        transition:
          grid-template-rows .88s cubic-bezier(.77,0,.175,1),
          clip-path .88s cubic-bezier(.77,0,.175,1),
          transform .88s cubic-bezier(.77,0,.175,1);
      }
      #${root.id} .tda-res-inline-drawer.is-open {
        grid-template-rows: 1fr;
        clip-path: inset(0 0 0 0);
        transform: translateY(0);
      }
      #${root.id} .tda-res-inline-drawer__inner {
        min-height: 0;
        overflow: hidden;
        padding-top: 0;
        transition: padding-top .88s cubic-bezier(.77,0,.175,1);
      }
      #${root.id} .tda-res-inline-drawer.is-open > .tda-res-inline-drawer__inner {
        padding-top: 10px;
      }
      /* Standard allocation waitlists do not have the quiet next-allocation row
         above them, so give the reveal the same breathing room before its title. */
      #${root.id} .tda-reservation-waitlist.is-standard-waitlist.is-open > .tda-res-inline-drawer__inner {
        padding-top: 22px;
      }
      /* Keep Step 1 anchored while an inline drawer grows. The Gift Card delivery
         treatment opens downward; this prevents the vertically-centred allocation
         stack from re-centring upward as the waitlist gains height. */
      #${root.id} [data-tda-res-step="1"] .tda-reservation-step__content.tda-res-step1-drawer-anchor {
        display: block !important;
        align-items: initial !important;
        justify-content: initial !important;
        padding-top: var(--tda-res-step1-anchor-top, 44px) !important;
      }
      #${root.id} .tda-res-private-card {
        padding: 18px 18px 16px;
        border: 1px solid #E8E6E1;
        border-radius: 8px;
        background: #fff;
        text-align: left;
      }
      #${root.id} .tda-res-private-card + .tda-res-private-card { margin-top: 10px; }
      #${root.id} .tda-res-private-card__eyebrow {
        display: block;
        margin-bottom: 7px;
        font: 500 9px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif;
        letter-spacing: .11em;
        text-transform: uppercase;
        color: var(--tda-accent, #947239);
      }
      #${root.id} .tda-res-private-card strong {
        display: block;
        margin: 0;
        font-family: Didot, "Bodoni 72", "Times New Roman", serif;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.12;
        letter-spacing: -.012em;
        color: #171717;
      }
      #${root.id} .tda-res-private-card p {
        margin: 8px 0 0;
        font: 400 11px/1.55 "Helvetica Neue", Helvetica, Arial, sans-serif;
        color: #77736d;
      }
      #${root.id} .tda-res-private-card__action {
        width: 100%;
        min-height: 46px;
        margin-top: 15px;
        padding: 11px 18px;
        border: 1px solid var(--tda-accent, #947239);
        border-radius: 999px;
        background: var(--tda-accent, #947239);
        color: #fff;
        font: 500 11px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif;
        cursor: pointer;
        transition: transform .3s cubic-bezier(.22,.61,.36,1), box-shadow .3s ease, opacity .28s ease;
      }
      #${root.id} .tda-res-private-card__action:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(0,0,0,.08); }
      #${root.id} .tda-res-private-card__action.is-selected { background: #171717; border-color: #171717; }
      #${root.id} .tda-res-private-nearest {
        margin-top: 2px;
        padding: 20px 18px 18px;
        background: #fff;
      }
      #${root.id} .tda-res-private-nearest strong { font-size: 20px; }

      #${root.id} .tda-reservation-waitlist.is-inline-drawer {
        margin: 0 auto !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
      }
      #${root.id} .tda-reservation-waitlist.is-inline-drawer [data-tda-res-waitlist-back] { display: none !important; }
      #${root.id} .tda-reservation-waitlist.is-inline-drawer .tda-reservation-step__label {
        margin-top: 0 !important;
        color: var(--tda-accent, #947239);
      }
      #${root.id} .tda-reservation-waitlist.is-inline-drawer h3 {
        margin: 2px 0 0 !important;
        font-family: Didot, "Bodoni 72", "Times New Roman", serif !important;
        font-size: 16.5px !important;
        font-weight: 400 !important;
        line-height: 1.12 !important;
      }
      #${root.id} .tda-reservation-waitlist.is-inline-drawer > .tda-res-inline-drawer__inner > p:not(.tda-reservation-step__label) {
        margin: 6px 0 0 !important;
        font: 400 9.4px/1.45 "Helvetica Neue", Helvetica, Arial, sans-serif !important;
        color: #77736d !important;
      }
      #${root.id} .tda-reservation-waitlist__form { margin-top: 7px !important; }
      #${root.id} .tda-reservation-waitlist__form > label:not(.tda-reservation-waitlist__marketing).tda-res-dior-field {
        position: relative;
        display: block;
        min-height: 35px;
        margin-top: 5px;
        padding: 2px 0 4px;
        border: 0;
        border-radius: 0;
        background: transparent;
        text-align: left;
      }
      #${root.id} .tda-reservation-waitlist__form > label:not(.tda-reservation-waitlist__marketing).tda-res-dior-field:first-of-type { margin-top: 0; }
      #${root.id} .tda-res-dior-field > span:first-child {
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 2;
        margin: 0 !important;
        transform: translateY(-58%);
        transform-origin: left top;
        font: 400 9.7px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        color: #55524D !important;
        pointer-events: none;
        transition: top .46s cubic-bezier(.77,0,.175,1), transform .46s cubic-bezier(.77,0,.175,1), font-size .46s cubic-bezier(.77,0,.175,1), color .3s ease;
      }
      #${root.id} .tda-res-dior-field.is-active > span:first-child,
      #${root.id} .tda-res-dior-field.is-valid > span:first-child,
      #${root.id} .tda-res-dior-field.is-invalid > span:first-child {
        top: 2px;
        transform: translateY(0);
        font-size: 7.8px !important;
        color: #8A8781 !important;
      }
      #${root.id} .tda-res-dior-field input {
        display: block !important;
        width: 100% !important;
        min-height: 27px !important;
        padding: 11px 22px 0 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
        color: #171717 !important;
        font: 500 10.5px/1.3 "Helvetica Neue", Helvetica, Arial, sans-serif !important;
        opacity: 0;
        transition: opacity .2s ease .08s;
      }
      #${root.id} .tda-res-dior-field.is-active input,
      #${root.id} .tda-res-dior-field.is-valid input,
      #${root.id} .tda-res-dior-field.is-invalid input { opacity: 1; }
      #${root.id} .tda-res-input-line {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 2px;
        height: 2px;
        background: linear-gradient(to bottom, transparent 0, transparent .5px, #D7D4CE .5px, #D7D4CE 1.5px, transparent 1.5px);
      }
      #${root.id} .tda-res-input-line::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: #171717;
        transform: scaleX(0) translateY(1px);
        transform-origin: left center;
        transition: transform .62s cubic-bezier(.77,0,.175,1), height .38s ease, background-color .28s ease;
      }
      #${root.id} .tda-res-dior-field.is-active .tda-res-input-line::after,
      #${root.id} .tda-res-dior-field.is-valid .tda-res-input-line::after { transform: scaleX(1) translateY(0); }
      #${root.id} .tda-res-valid-tick {
        position: absolute;
        right: 2px;
        bottom: 8px;
        width: 10px;
        height: 6px;
        border-left: 1.5px solid var(--tda-accent, #947239);
        border-bottom: 1.5px solid var(--tda-accent, #947239);
        opacity: 0;
        transform: rotate(-45deg) scale(.72);
        transition: opacity .28s ease, transform .34s cubic-bezier(.22,.61,.36,1);
        pointer-events: none;
      }
      #${root.id} .tda-res-dior-field.is-valid .tda-res-valid-tick { opacity: 1; transform: rotate(-45deg) scale(1); }
      #${root.id} .tda-res-dior-field.is-invalid .tda-res-input-line::after { background: #C44B42; transform: scaleX(1) translateY(0); }
      #${root.id} .tda-reservation-waitlist__marketing { margin-top: 7px !important; font-size: 8.6px !important; }
      #${root.id} .tda-reservation-waitlist.is-inline-drawer .tda-reservation-primary[type="submit"] {
        display: block !important;
        width: 68% !important;
        min-height: 34px !important;
        height: 34px !important;
        margin: 9px auto 0 !important;
        padding: 0 16px !important;
        border-radius: 999px !important;
        font-size: 9.5px !important;
      }
      #${root.id} .tda-reservation-waitlist.is-inline-drawer .tda-reservation-waitlist__consent {
        margin-top: 5px !important;
        font-size: 7.8px !important;
        line-height: 1.35 !important;
      }

      /* Calendar waiting list: override the older miniature form only here. */
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-res-waitlist-field {
        gap: 4px !important; margin-bottom: 8px !important;
      }
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-res-waitlist-field > span {
        font: 400 13px/1.5 var(--font-body-family) !important;
        letter-spacing: 0 !important; text-transform: none !important;
      }
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-res-waitlist-field :is(input,select) {
        font: 400 16px/1.5 var(--font-body-family) !important;
        border: 0 !important; border-bottom: 1px solid #cfcac4 !important;
        border-radius: 0 !important; min-height: 44px !important; padding: 8px 0 !important;
        background-color: transparent !important;
      }
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-reservation-waitlist__marketing,
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-reservation-waitlist__consent {
        font: 400 11px/1.5 var(--font-body-family) !important; margin: 8px 0 !important;
      }
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-reservation-waitlist__marketing span {
        font: inherit !important;
      }
      #${root.id} [data-tda-res-step="1"]:has(.tda-reservation-waitlist[aria-hidden="false"] [data-tda-waitlist-form]) [data-tda-res-next="2"] {
        display: none !important;
      }
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-reservation-primary[type="submit"] {
        width: 80% !important; min-height: 44px !important; height: auto !important; margin: 14px auto 0 !important;
        font-size: 14px !important; padding: 12px 20px !important;
      }
      #${root.id} .tda-reservation-waitlist [data-tda-waitlist-form] .tda-reservation-primary[hidden] { display:none !important; }

      #${root.id} .tda-calendar-waitlist [data-tda-waitlist-form] .tda-res-waitlist-form__contact .tda-res-dior-field {
        position:relative; display:block; min-height:48px; padding:0; margin:0 0 8px !important;
      }
      #${root.id} .tda-calendar-waitlist [data-tda-waitlist-form] .tda-res-dior-field > span:first-child {
        position:absolute; top:50%; transform:translateY(-58%); font-size:13px !important;
      }
      #${root.id} .tda-calendar-waitlist [data-tda-waitlist-form] .tda-res-dior-field.is-active > span:first-child {
        top:0; transform:translateY(0); font-size:10px !important;
      }
      #${root.id} .tda-calendar-waitlist [data-tda-waitlist-form] .tda-res-dior-field input {
        min-height:46px !important; padding:17px 22px 0 0 !important; border:0 !important;
      }
      #${root.id} .tda-calendar-waitlist [data-tda-waitlist-form] .tda-res-input-line { position:absolute; }
      #${root.id} .tda-calendar-waitlist [data-tda-waitlist-form] .tda-res-valid-tick { position:absolute; }

      @media(max-width:749px) {
        #${root.id} [data-tda-res-step="1"] .tda-reservation-step__content:has(.tda-calendar-waitlist) {
          margin-top:28px !important; padding-top:0 !important;
        }
      }

      /* v86 — bespoke Atelier symbols: transparent, proprietary and quiet. */
      /* v88 — one quiet, explicit product action.
         The underline performs a right-to-left wipe, disappears, then
         redraws from right to left and settles beneath the label. */
      #${root.id} .tda-discover-top-actions {
        display: flex;
        align-items: center;
        margin-top: 17px;
        padding-bottom: 8px;
      }
      #${root.id} .tda-discover-view-link {
        position: relative;
        display: inline-block;
        padding: 0 0 4px;
        border: 0;
        background: transparent;
        color: #34312d;
        text-decoration: none;
        font: 400 9.5px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif;
        letter-spacing: .018em;
        white-space: nowrap;
        cursor: pointer;
        transition: color .28s ease;
      }
      #${root.id} .tda-discover-view-link::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: .8px;
        background: currentColor;
        transform: scaleX(1);
        transform-origin: left center;
      }
      @keyframes tdaViewCreationLine {
        0% {
          transform: scaleX(1);
          transform-origin: left center;
        }
        42% {
          transform: scaleX(0);
          transform-origin: left center;
        }
        43% {
          transform: scaleX(0);
          transform-origin: right center;
        }
        100% {
          transform: scaleX(1);
          transform-origin: right center;
        }
      }
      @media (hover:hover) and (pointer:fine) {
        #${root.id} .tda-discover-view-link:hover,
        #${root.id} .tda-discover-view-link:focus-visible {
          color: var(--tda-accent, #947239);
          outline: 0;
        }
        #${root.id} .tda-discover-view-link:hover::after,
        #${root.id} .tda-discover-view-link:focus-visible::after {
          animation: tdaViewCreationLine .82s cubic-bezier(.77,0,.175,1) both;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        #${root.id} .tda-discover-view-link:hover::after,
        #${root.id} .tda-discover-view-link:focus-visible::after {
          animation: none;
        }
      }
      #${root.id} .tda-discover-view__explore { display: none !important; }
      #${root.id} .tda-discover-context-note {
        margin: 0 0 14px;
        color: #77736d;
        font: 400 11px/1.45 "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      #${root.id} .tda-discover-context-note strong {
        color: #171717;
        font-weight: 500;
      }
      #${root.id} .tda-discover-view__actions .tda-discover-view__primary[hidden],
      #${root.id} .tda-discover-view__actions .tda-discover-view__different[hidden] { display: none !important; }
      #${root.id} .tda-discover-view__different {
        margin-top: 10px !important;
      }
      #${root.id} .tda-discover-inline-add {
        display: grid;
        grid-template-rows: 0fr;
        opacity: 0;
        transform: translateY(-5px);
        clip-path: inset(0 0 100% 0);
        transition:
          grid-template-rows .82s cubic-bezier(.77,0,.175,1),
          clip-path .82s cubic-bezier(.77,0,.175,1),
          transform .82s cubic-bezier(.77,0,.175,1),
          opacity .36s ease;
      }
      #${root.id} .tda-discover-inline-add.is-open {
        grid-template-rows: 1fr;
        opacity: 1;
        transform: translateY(0);
        clip-path: inset(0 0 0 0);
      }
      #${root.id} .tda-discover-inline-add__inner {
        min-height: 0;
        overflow: hidden;
        padding-top: 0;
        transition: padding-top .82s cubic-bezier(.77,0,.175,1);
      }
      #${root.id} .tda-discover-inline-add.is-open .tda-discover-inline-add__inner { padding-top: 16px; }
      #${root.id} .tda-discover-inline-add__label {
        margin: 0 0 12px;
        color: #77736d;
        font: 400 10.5px/1.45 "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      #${root.id} .tda-discover-inline-add__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 13px 0 15px;
        border-top: 1px solid rgba(23,23,23,.11);
      }
      #${root.id} .tda-discover-inline-add__row strong {
        font-family: Didot, "Bodoni 72", "Times New Roman", serif;
        font-size: 17px;
        font-weight: 400;
        line-height: 1.15;
      }
      #${root.id} .tda-discover-mini-qty {
        display: inline-flex;
        align-items: center;
        min-width: 94px;
        height: 36px;
        border: 1px solid rgba(23,23,23,.17);
        border-radius: 999px;
        overflow: hidden;
      }
      #${root.id} .tda-discover-mini-qty button {
        width: 32px;
        height: 34px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #171717;
        font: 400 15px/1 "Helvetica Neue", Helvetica, Arial, sans-serif;
        cursor: pointer;
      }
      #${root.id} .tda-discover-mini-qty button:disabled { opacity: .28; cursor: default; }
      #${root.id} .tda-discover-mini-qty span {
        min-width: 28px;
        text-align: center;
        font: 500 11px/1 "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      #${root.id} .tda-discover-inline-add__confirm {
        width: 100%;
        min-height: 48px;
        margin-top: 2px;
        border: 1px solid var(--tda-accent, #947239);
        border-radius: 999px;
        background: var(--tda-accent, #947239);
        color: #fff;
        font: 500 11px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif;
        cursor: pointer;
        transition: opacity .28s ease, transform .32s cubic-bezier(.22,.61,.36,1);
      }
      #${root.id} .tda-discover-inline-add__confirm.is-done { background: #171717; border-color: #171717; }
      #${root.id} .tda-discover-inline-add__error {
        margin: 10px 0 0;
        color: #8b423c;
        font: 400 10px/1.45 "Helvetica Neue", Helvetica, Arial, sans-serif;
      }

      #${root.id} .tda-res-private-screen {
        margin-top: 26px;
        text-align: left;
        animation: tdaResPrivateIn .62s cubic-bezier(.22,.61,.36,1) both;
      }
      @keyframes tdaResPrivateIn {
        from { opacity: 0; transform: translateX(10px); }
        to { opacity: 1; transform: translateX(0); }
      }
      #${root.id} .tda-res-private-screen[hidden] { display: none !important; }
      #${root.id} .tda-res-private-screen__eyebrow {
        display: block;
        margin: 0 0 8px;
        color: var(--tda-accent, #947239);
        font: 500 9px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif;
        letter-spacing: .08em;
        text-transform: none;
      }
      #${root.id} .tda-res-private-screen h3 {
        margin: 0;
        color: #171717;
        font-family: Didot, "Bodoni 72", "Times New Roman", serif;
        font-size: 20px;
        font-weight: 400;
        line-height: 1.15;
        letter-spacing: -.01em;
      }
      #${root.id} .tda-res-private-screen p {
        margin: 10px 0 0;
        color: #77736d;
        font: 400 11px/1.55 "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      #${root.id} .tda-res-private-screen__next {
        margin-top: 24px;
        padding-top: 22px;
        border-top: 1px solid #e5e3df;
      }

      #${root.id} .tda-res-selected-creations { display: grid; gap: 0; }
      #${root.id} .tda-res-add-more-toggle {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-top: 8px;
        padding: 15px 0 10px;
        border: 0;
        border-top: 1px solid #e6e4e0;
        background: transparent;
        color: #171717;
        font: 400 11px/1.3 "Helvetica Neue", Helvetica, Arial, sans-serif;
        text-align: left;
        cursor: pointer;
        transition: color .28s ease;
      }
      #${root.id} .tda-res-add-more-toggle:hover,
      #${root.id} .tda-res-add-more-toggle:focus-visible {
        color: var(--tda-accent, #947239);
        outline: none;
      }
      #${root.id} .tda-res-add-more-toggle__mark {
        width: 16px;
        height: 16px;
        position: relative;
        flex: 0 0 16px;
      }
      #${root.id} .tda-res-add-more-toggle__mark::before,
      #${root.id} .tda-res-add-more-toggle__mark::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 10px;
        height: 1px;
        background: currentColor;
        transform: translate(-50%,-50%);
        transition: transform .55s cubic-bezier(.77,0,.175,1);
      }
      #${root.id} .tda-res-add-more-toggle__mark::after { transform: translate(-50%,-50%) rotate(90deg); }
      #${root.id} .tda-res-add-more-toggle[aria-expanded="true"] .tda-res-add-more-toggle__mark::after { transform: translate(-50%,-50%) rotate(0deg); }
      #${root.id} .tda-res-add-more-drawer > .tda-res-inline-drawer__inner { padding-top: 0; }
      #${root.id} .tda-res-add-more-drawer.is-open > .tda-res-inline-drawer__inner { padding-top: 16px; }
      #${root.id} .tda-res-add-option {
        width: 100%;
        display: grid;
        grid-template-columns: 38px minmax(0,1fr) 24px;
        align-items: center;
        gap: 12px;
        min-height: 58px;
        padding: 9px 0;
        border: 0;
        border-bottom: 1px solid #eceae6;
        background: transparent;
        color: #171717;
        text-align: left;
        cursor: pointer;
      }
      #${root.id} .tda-res-add-option:last-child { border-bottom: 0; }
      #${root.id} .tda-res-add-option__image {
        width: 38px;
        height: 38px;
        display: grid;
        place-items: center;
        background: #f7f6f4;
        overflow: hidden;
      }
      #${root.id} .tda-res-add-option__image img { width: 100%; height: 100%; object-fit: contain; display: block; }
      #${root.id} .tda-res-add-option__copy strong,
      #${root.id} .tda-res-add-option__copy small { display: block; }
      #${root.id} .tda-res-add-option__copy strong {
        font: 500 11px/1.25 "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      #${root.id} .tda-res-add-option__copy small {
        margin-top: 3px;
        color: #77736d;
        font: 400 10px/1.25 "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      #${root.id} .tda-res-add-option__plus {
        justify-self: end;
        font: 300 20px/1 "Helvetica Neue", Helvetica, Arial, sans-serif;
        transition: color .28s ease, transform .28s ease;
      }
      #${root.id} .tda-res-add-option:hover .tda-res-add-option__plus,
      #${root.id} .tda-res-add-option:focus-visible .tda-res-add-option__plus {
        color: var(--tda-accent, #947239);
        transform: scale(1.08);
      }
      #${root.id} .tda-res-add-option:focus-visible { outline: none; }

      @media (prefers-reduced-motion: reduce) {
        #${root.id} .tda-res-inline-drawer,
        #${root.id} .tda-res-inline-drawer__inner,
        #${root.id} .tda-res-dior-field > span:first-child,
        #${root.id} .tda-res-input-line::after { transition-duration: 1ms !important; }
      }
    `;
    document.head.appendChild(style);
  };

  const releaseStep1DrawerAnchor = () => {
    if (!step1Content) return;
    step1Content.classList.remove('tda-res-step1-drawer-anchor');
    step1Content.style.removeProperty('--tda-res-step1-anchor-top');
  };

  const anchorStep1ForInlineDrawer = () => {
    if (!step1Content) return;
    const anchor = step1Content.querySelector(':scope > .tda-reservation-step__label:not([hidden]), :scope > h2:not([hidden]), :scope > .tda-reservation-step__copy:not([hidden])');
    if (!anchor) return;

    /* Measure the live centred position before changing the layout model. */
    const contentRect = step1Content.getBoundingClientRect();
    const anchorRect = anchor.getBoundingClientRect();
    const anchorTop = Math.max(0, anchorRect.top - contentRect.top + step1Content.scrollTop);
    step1Content.style.setProperty('--tda-res-step1-anchor-top', `${anchorTop}px`);
    step1Content.classList.add('tda-res-step1-drawer-anchor');
  };


  const releaseStep2DrawerAnchor = () => {
    if (!step2Content) return;
    step2Content.classList.remove('tda-res-step2-drawer-anchor');
    step2Content.style.removeProperty('--tda-res-step2-anchor-top');
  };

  const anchorStep2ForInlineDrawer = () => {
    if (!step2Content) return;
    const anchor = step2Content.querySelector(
      ':scope > .tda-reservation-step__label:not([hidden]), :scope > h2:not([hidden]), :scope > .tda-reservation-step__copy:not([hidden])'
    );
    if (!anchor) return;

    const contentRect = step2Content.getBoundingClientRect();
    const anchorRect = anchor.getBoundingClientRect();
    const anchorTop = Math.max(0, anchorRect.top - contentRect.top + step2Content.scrollTop);
    step2Content.style.setProperty('--tda-res-step2-anchor-top', `${anchorTop}px`);
    step2Content.classList.add('tda-res-step2-drawer-anchor');
  };

  let addMoreDrawerCloseTimer = null;

  const closeAddMoreInline = () => {
    const toggle = creationsList?.querySelector('[data-tda-res-add-more-toggle]');
    const drawerEl = creationsList?.querySelector('[data-tda-res-add-more-drawer]');

    addMoreOpen = false;
    if (addMoreDrawerCloseTimer) {
      window.clearTimeout(addMoreDrawerCloseTimer);
      addMoreDrawerCloseTimer = null;
    }

    toggle?.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    drawerEl?.classList.remove('is-open');
    drawerEl?.setAttribute('aria-hidden', 'true');

    addMoreDrawerCloseTimer = window.setTimeout(() => {
      addMoreDrawerCloseTimer = null;
      releaseStep2DrawerAnchor();
    }, 900);
  };

  const openAddMoreInline = () => {
    const toggle = creationsList?.querySelector('[data-tda-res-add-more-toggle]');
    const drawerEl = creationsList?.querySelector('[data-tda-res-add-more-drawer]');
    if (!toggle || !drawerEl) return;

    if (addMoreDrawerCloseTimer) {
      window.clearTimeout(addMoreDrawerCloseTimer);
      addMoreDrawerCloseTimer = null;
    }

    anchorStep2ForInlineDrawer();
    addMoreOpen = true;

    /* Paint the fully collapsed state first, then reveal downward on the next
       two frames — identical choreography to Join the List. */
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');
    void drawerEl.offsetHeight;

    requestAnimationFrame(() => requestAnimationFrame(() => {
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      drawerEl.classList.add('is-open');
      drawerEl.setAttribute('aria-hidden', 'false');
    }));
  };

  let waitlistDrawerCloseTimer = null;
  let activeWaitlistTrigger = null;

  const resetWaitlistTrigger = () => {
    if (!activeWaitlistTrigger) return;
    activeWaitlistTrigger.classList.remove('is-open');
    activeWaitlistTrigger.setAttribute('aria-expanded', 'false');
    activeWaitlistTrigger = null;
  };

  const parkWaitlist = () => {
    if (!waitlist || !waitlistHome) return;
    if (waitlistDrawerCloseTimer) {
      window.clearTimeout(waitlistDrawerCloseTimer);
      waitlistDrawerCloseTimer = null;
    }
    waitlist.classList.remove('is-inline-drawer', 'tda-res-inline-drawer', 'is-open', 'is-standard-waitlist');
    waitlist.setAttribute('aria-hidden', 'true');
    resetWaitlistTrigger();
    waitlist.hidden = true;
    if (waitlistNextSibling && waitlistNextSibling.parentNode === waitlistHome) waitlistHome.insertBefore(waitlist, waitlistNextSibling);
    else waitlistHome.appendChild(waitlist);
    releaseStep1DrawerAnchor();
  };

  const closeWaitlistInline = () => {
    if (!waitlist || waitlist.hidden || !waitlist.classList.contains('is-inline-drawer')) return;
    if (waitlistDrawerCloseTimer) window.clearTimeout(waitlistDrawerCloseTimer);

    waitlist.classList.remove('is-open');
    waitlist.setAttribute('aria-hidden', 'true');

    allocationList?.querySelectorAll('.tda-res-allocation-option.is-selected').forEach(btn => {
      if (btn.dataset.tdaResSelectable !== 'true') btn.classList.remove('is-selected');
    });

    const continueButton = reservationView.querySelector('[data-tda-res-next="2"]');
    if (continueButton) continueButton.disabled = !draftHasAllocation();
    setVisual('allocation');

    waitlistDrawerCloseTimer = window.setTimeout(() => {
      waitlistDrawerCloseTimer = null;
      parkWaitlist();
    }, 900);
  };

  const prepareWaitlistMicroFields = () => {
    if (!waitlist) return;
    if (bookingCalendar) {
      const heading = waitlist.querySelector('h3');
      if (heading) heading.textContent = 'Join the waiting list';
      const eyebrow = waitlist.querySelector('.tda-reservation-step__label');
      if (eyebrow) eyebrow.hidden = true;
      waitlist.classList.add('tda-calendar-waitlist');
      if (!waitlist.querySelector(':scope > .tda-res-inline-drawer__inner')) {
        const inner = document.createElement('div');
        inner.className = 'tda-res-inline-drawer__inner';
        while (waitlist.firstChild) inner.appendChild(waitlist.firstChild);
        waitlist.appendChild(inner);
      }
      return;
    }

    /* Keep the reservation waitlist language exactly aligned with the established Atelier treatment. */
    const eyebrow = waitlist.querySelector('.tda-reservation-step__label');
    if (eyebrow) eyebrow.hidden = true;
    const heading = waitlist.querySelector('h3');
    if (heading) heading.textContent = 'Register your interest';
    if (waitlistCopy) waitlistCopy.textContent = 'Be among the first to know when the next allocation opens.';
    const marketingCopy = waitlist.querySelector('.tda-reservation-waitlist__marketing span:last-child');
    if (marketingCopy) marketingCopy.textContent = 'I’d also like to receive private invitations.';
    const submit = waitlist.querySelector('.tda-reservation-waitlist__form button[type="submit"]');
    if (submit) submit.textContent = 'Join the List';

    const form = waitlist.querySelector('.tda-reservation-waitlist__form');
    if (form) {
      const labels = [...form.querySelectorAll(':scope > label:not(.tda-reservation-waitlist__marketing)')];
      if (labels[0]?.querySelector(':scope > span:first-child')) labels[0].querySelector(':scope > span:first-child').textContent = 'First name';
      if (labels[1]?.querySelector(':scope > span:first-child')) labels[1].querySelector(':scope > span:first-child').textContent = 'Email address';
    }

    if (waitlist.dataset.tdaMicroReady === 'true') return;
    waitlist.dataset.tdaMicroReady = 'true';

    let inner = waitlist.querySelector(':scope > .tda-res-inline-drawer__inner');
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'tda-res-inline-drawer__inner';
      while (waitlist.firstChild) inner.appendChild(waitlist.firstChild);
      waitlist.appendChild(inner);
    }

    const microForm = waitlist.querySelector('.tda-reservation-waitlist__form');
    if (!microForm) return;
    const fieldLabels = [...microForm.querySelectorAll(':scope > label:not(.tda-reservation-waitlist__marketing)')];
    fieldLabels.forEach((label) => {
      const input = label.querySelector('input');
      if (!input) return;
      label.classList.add('tda-res-dior-field');
      if (!label.querySelector('.tda-res-input-line')) {
        const line = document.createElement('span');
        line.className = 'tda-res-input-line';
        label.appendChild(line);
      }
      if (!label.querySelector('.tda-res-valid-tick')) {
        const tick = document.createElement('span');
        tick.className = 'tda-res-valid-tick';
        tick.setAttribute('aria-hidden','true');
        label.appendChild(tick);
      }
      const sync = (touch = false) => {
        const value = input.value.trim();
        const focused = document.activeElement === input;
        label.classList.toggle('is-active', focused || !!value);
        let valid = !!value;
        if (input.type === 'email' && value) valid = input.checkValidity();
        label.classList.toggle('is-valid', valid);
        label.classList.toggle('is-invalid', touch && !!value && !valid);
      };
      input.addEventListener('focus', () => sync(false));
      input.addEventListener('input', () => sync(false));
      input.addEventListener('change', () => sync(false));
      input.addEventListener('blur', () => sync(true));
      sync(false);
    });
  };

  injectGiftCardMicroStyles();
  injectReservationBagLoadingStyles();
  prepareBagButton();
  setBagButtonLabel('Add to bag');
  prepareWaitlistMicroFields();
  const buildNextButton = reservationView.querySelector('[data-tda-res-next="3"]');
  if (buildNextButton) buildNextButton.textContent = 'Continue';
  const saveContinueButton = reservationView.querySelector('[data-tda-res-save]');
  if (saveContinueButton) {
    const span = saveContinueButton.querySelector('span');
    if (span) span.textContent = 'Add to bag & continue browsing';
    else saveContinueButton.textContent = 'Add to bag & continue browsing';
  }

  const loadStore = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '{}');
      return {
        groups: Array.isArray(parsed.groups) ? parsed.groups : [],
        activeId: parsed.activeId || null
      };
    } catch (_) { return { groups: [], activeId: null }; }
  };

  const saveStore = (store) => {
    try { localStorage.setItem(storageKey, JSON.stringify(store)); } catch (_) {}
    updateActivePill();
  };

  /* v61: the old persistent "current allocation" context is retired.
     Every Reserve action starts a clean reservation flow. */
  try { localStorage.removeItem(activeContextKey); } catch (_) {}
  const countItems = (group) => Object.values(group?.items || {}).reduce((sum, item) => sum + Number(item.quantity || 0), 0);

  const allocationKey = (value) => String(value || '')
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim().toLowerCase();

  const stripEditionYear = (value) => String(value || '').replace(/\s+20\d{2}\s*$/, '').trim();

  const allocationWindowTitle = (value) => {
    const raw = stripEditionYear(value);
    if (!raw) return '';
    return raw.toLocaleLowerCase('en-GB').replace(/(^|[\s&/+-])([a-zà-žœ])/giu, (_, lead, letter) => `${lead}${letter.toLocaleUpperCase('en-GB')}`);
  };

  const allocationDisplay = (group) => {
    if (!group) return '';
    if (group.allocationType === 'private') return 'Private occasions';
    const edition = group.allocationLabel || group.allocationName || 'Reservation';
    const windowName = group.allocationWindowName || '';
    if (windowName && allocationKey(stripEditionYear(windowName)) !== allocationKey(stripEditionYear(edition))) {
      const windowTitle = allocationWindowTitle(windowName);
      return windowTitle ? `${edition} · ${windowTitle} allocation` : edition;
    }
    return edition;
  };

  const updateActivePill = () => {
    /* v44: reservation context is remembered silently; the normal bag is the visible customer reference. */
    if (activePill) activePill.hidden = true;
  };

  const productVariant = (product, allocationName) => {
    if (!product || !allocationName) return null;
    if (bookingCalendar) {
      const slot = selectedSlot() || bookingCalendar.slots.find(item=>item.allocationName === allocationName);
      const variant = slot?.variants?.[String(product.id)];
      return variant ? {...variant,allocation:allocationName,available:calendarApi.slotState(slot,bookingCalendar)==='available',maxQuantity:config.maxQuantity || 4} : null;
    }
    const wanted = allocationKey(allocationName);
    return (product.variants || []).find(variant => allocationKey(variant.allocation) === wanted) || null;
  };

  /* v90 — An Atelier release is now the Édition. Its referenced Atelier
     allocation entries own the reservation and delivery windows. The central
     reservation product still uses one stable variant value per Édition, so
     RAMADAN & EID can expose two date windows without duplicating variants. */
  const releaseAllocationName = (release) => stripEditionYear(release?.name || '');

  const releaseAllocations = (release) => {
    const nested = Array.isArray(release?.allocations)
      ? release.allocations.filter(item => item && (item.name || item.open || item.close || item.deliveryFrom || item.deliveryUntil))
      : [];
    if (nested.length) {
      return nested.slice().sort((a,b) => Number(a.sortOrder || 999) - Number(b.sortOrder || 999));
    }

    /* Safe compatibility with the pre-v90 flat release JSON while a theme
       rollback or cached section is still in circulation. */
    if (release && (release.open || release.close || release.deliveryFrom || release.deliveryUntil || release.period)) {
      return [{
        name: release.name || '', sortOrder: 1,
        open: release.open || '', close: release.close || '', period: release.period || '',
        deliveryFrom: release.deliveryFrom || '', deliveryUntil: release.deliveryUntil || '',
        dispatch: release.dispatch || release.close || ''
      }];
    }
    return [];
  };

  const activeReleaseKey = () => allocationKey(config.activeReleaseAllocation || '');
  const releaseCapacityRemaining = () => {
    if (bookingCalendar) return draft?.allocationType==='private' ? Math.max(0,...calendarApi.availableSlots(bookingCalendar).filter(s=>s.kind==='private').map(calendarApi.remaining)) : calendarApi.remaining(selectedSlot());
    const value = Number(config.releaseRemaining);
    return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
  };

  const releaseMatchesActiveAllocation = (release) => {
    const active = activeReleaseKey();
    if (!active) return false;
    return allocationKey(releaseAllocationName(release)) === active;
  };

  const seasonalDraftHasCapacity = () => {
    if (!draft || draft.allocationType !== 'seasonal') return false;
    if (bookingCalendar) return calendarApi.slotState(selectedSlot(),bookingCalendar) === 'available';
    return allocationKey(draft.allocationName) === activeReleaseKey() && releaseCapacityRemaining() > 0;
  };

  const parseCalendarDate = (value, endOfDay = false) => {
    if (!value) return null;
    const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const d = new Date(Number(match[1]), Number(match[2])-1, Number(match[3]), endOfDay ? 23 : 0, endOfDay ? 59 : 0, endOfDay ? 59 : 0, endOfDay ? 999 : 0);
    return Number.isNaN(d.getTime()) ? null : d;
  };

  const releaseState = (schedule) => {
    const now = new Date(); now.setHours(12,0,0,0);
    const open = parseCalendarDate(schedule?.open);
    const close = parseCalendarDate(schedule?.close, true);
    if (open && now < open) return { status:'upcoming', open, close };
    if (close && now > close) return { status:'closed', open, close };
    if (open || close) return { status:'open', open, close };
    return { status:'unscheduled', open:null, close:null };
  };

  const formatDate = (date) => {
    if (!date) return '';
    try { return new Intl.DateTimeFormat('en-GB', { day:'numeric', month:'long', year:'numeric' }).format(date); }
    catch (_) { return ''; }
  };

  const isoLocal = (date) => {
    if (!date) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const formatHumanDate = (value) => {
    const date = typeof value === 'string' ? parseCalendarDate(value) : value;
    if (!date) return '';
    try { return new Intl.DateTimeFormat('en-GB', { day:'numeric', month:'long', year:'numeric' }).format(date); }
    catch (_) { return ''; }
  };

  const formatDayMonth = (date, shortMonth = false) => {
    if (!date) return '';
    try {
      return new Intl.DateTimeFormat('en-GB', {
        day:'numeric',
        month: shortMonth ? 'short' : 'long'
      }).format(date);
    } catch (_) { return ''; }
  };

  const formatDeliveryRange = (start, end) => {
    if (!start || !end) return '';
    return `${formatDayMonth(start, true)}–${formatDayMonth(end, true)}`;
  };

  const relevantAllocationForRelease = (release) => {
    const rows = releaseAllocations(release).map((allocation,index) => ({ allocation, index, ...releaseState(allocation) }));
    if (!rows.length) return null;

    const openRows = rows.filter(item => item.status === 'open')
      .sort((a,b)=>(a.close?.getTime()||Number.MAX_SAFE_INTEGER)-(b.close?.getTime()||Number.MAX_SAFE_INTEGER));
    if (openRows.length) return openRows[0];

    const upcomingRows = rows.filter(item => item.status === 'upcoming')
      .sort((a,b)=>(a.open?.getTime()||Number.MAX_SAFE_INTEGER)-(b.open?.getTime()||Number.MAX_SAFE_INTEGER));
    if (upcomingRows.length) return upcomingRows[0];

    const unscheduled = rows.find(item => item.status === 'unscheduled');
    if (unscheduled) return unscheduled;

    return rows.filter(item => item.status === 'closed')
      .sort((a,b)=>(b.close?.getTime()||0)-(a.close?.getTime()||0))[0] || rows[0];
  };

  const nextUpcomingAllocationForRelease = (release, currentAllocation) => {
    if (!release || !currentAllocation) return null;
    const currentOrder = Number(currentAllocation.sortOrder || 0);
    const currentKey = allocationKey(currentAllocation.name || '');
    return releaseAllocations(release)
      .map((allocation,index) => ({ allocation, index, ...releaseState(allocation) }))
      .filter(item => item.status === 'upcoming'
        && allocationKey(item.allocation?.name || '') !== currentKey
        && Number(item.allocation?.sortOrder || item.index + 1) > currentOrder)
      .sort((a,b)=>(a.open?.getTime()||Number.MAX_SAFE_INTEGER)-(b.open?.getTime()||Number.MAX_SAFE_INTEGER))[0] || null;
  };

  const releaseForDraft = () => {
    if (!draft?.allocationName) return null;
    const wanted = allocationKey(draft.allocationName);
    return (config.releases || []).find(item => allocationKey(releaseAllocationName(item)) === wanted) || null;
  };

  const allocationForDraft = (release = releaseForDraft()) => {
    if (!release) return null;
    const allocations = releaseAllocations(release);
    const wantedWindow = allocationKey(draft?.allocationWindowName || '');
    if (wantedWindow) {
      const exact = allocations.find(item => allocationKey(item.name) === wantedWindow);
      if (exact) return exact;
    }
    return relevantAllocationForRelease(release)?.allocation || allocations[0] || null;
  };

  const parseLooseDispatchDate = (schedule, release = null) => {
    if (!schedule && !release) return null;
    const candidates = [schedule?.deliveryFrom, schedule?.dispatch, schedule?.close, release?.deliveryFrom, release?.dispatch, release?.close].filter(Boolean);
    for (const value of candidates) {
      const exact = parseCalendarDate(String(value));
      if (exact) return exact;
      const match = String(value).match(/\b(\d{1,2})\s+(January|February|March|April|May|June|July|August|September|October|November|December)(?:\s+(\d{4}))?/i);
      if (match) {
        const year = Number(match[3] || (String(schedule?.period || release?.period || '').match(/\b(20\d{2})\b/)?.[1]) || new Date().getFullYear());
        const parsed = new Date(`${match[2]} ${match[1]}, ${year} 12:00:00`);
        if (!Number.isNaN(parsed.getTime())) return parsed;
      }
    }
    return null;
  };

  const privateWeekBounds = () => {
    const parsedStart = parseCalendarDate(draft?.privateWeekStart || '');
    if (parsedStart) {
      const start = new Date(parsedStart); start.setHours(12,0,0,0);
      const end = new Date(start); end.setDate(start.getDate() + 6);
      return { start, end };
    }
    const today = new Date(); today.setHours(12,0,0,0);
    const day = today.getDay();
    const mondayOffset = day === 0 ? -6 : 1 - day;
    const start = new Date(today); start.setDate(today.getDate() + mondayOffset);
    const end = new Date(start); end.setDate(start.getDate() + 6);
    return { start, end };
  };

  const deliveryRules = () => {
    if (bookingCalendar) {
      const slot = selectedSlot();
      const dates = draft?.allocationType==='private' ? calendarApi.privateDates(bookingCalendar,Math.max(1,draftCount())) : calendarApi.deliveryDates(slot,bookingCalendar);
      const rangeLabel = slot ? formatDeliveryRange(parseCalendarDate(slot.deliveryFrom),parseCalendarDate(slot.deliveryUntil)) : '';
      const earliest=draft?.allocationType==='private' ? calendarApi.earliestPrivateSlot(bookingCalendar,Math.max(1,draftCount())) : null;
      const weekLabel=earliest ? privateWeekLabel(parseCalendarDate(earliest.weekStart)) : '';
      return {standardLabel:earliest?'Earliest available delivery':'Any time within this window',summaryLabel:earliest?weekLabel:rangeLabel,weekLabel,rangeLabel,min:dates[0] || '',max:dates.at(-1) || '',dates};
    }
    if (draft?.allocationType === 'private') {
      const { start, end } = privateWeekBounds();
      const label = draft.deliveryWeek ? `Atelier allocation · ${draft.deliveryWeek}` : 'Atelier allocation';
      return { standardLabel: label, summaryLabel: label, rangeLabel:'', min: isoLocal(start), max: isoLocal(end) };
    }

    const release = releaseForDraft();
    const allocation = allocationForDraft(release);
    const deliveryFrom = parseCalendarDate(allocation?.deliveryFrom || '');
    const deliveryUntil = parseCalendarDate(allocation?.deliveryUntil || '');

    if (deliveryFrom) {
      const fromText = formatDayMonth(deliveryFrom, false);
      return {
        standardLabel: `From ${fromText}`,
        summaryLabel: `From ${fromText}`,
        rangeLabel: deliveryUntil ? formatDeliveryRange(deliveryFrom, deliveryUntil) : '',
        min: isoLocal(deliveryFrom),
        max: deliveryUntil ? isoLocal(deliveryUntil) : ''
      };
    }

    /* Compatibility fallback for older data that has not yet moved delivery
       dates into the linked Atelier allocation entry. */
    const threshold = parseLooseDispatchDate(allocation, release);
    if (threshold) {
      const firstChoice = new Date(threshold);
      firstChoice.setDate(firstChoice.getDate() + 1);
      const fromText = formatDayMonth(firstChoice, false);
      return {
        standardLabel: `From ${fromText}`,
        summaryLabel: `From ${fromText}`,
        rangeLabel: '',
        min: isoLocal(firstChoice),
        max: ''
      };
    }

    const fallback = allocation?.period || release?.period || 'the Édition';
    return { standardLabel: `During ${fallback}`, summaryLabel: `During ${fallback}`, rangeLabel:'', min:'', max:'' };
  };

  const scheduleOptions = (seedProduct) => {
    const releases = (config.releases || []).filter(item => item?.name && releaseAllocations(item).length);
    const rows = releases.map((release,index) => {
      const resolved = relevantAllocationForRelease(release);
      if (!resolved) return null;
      const allocationName = releaseAllocationName(release);
      const variant = productVariant(seedProduct, allocationName);
      return { release, index, allocationName, variant, ...resolved };
    }).filter(Boolean);

    const scheduled = rows.some(item => item.open || item.close);
    let visible = [];
    if (scheduled) {
      const openRows = rows.filter(item => item.status === 'open')
        .sort((a,b)=>(a.close?.getTime()||Number.MAX_SAFE_INTEGER)-(b.close?.getTime()||Number.MAX_SAFE_INTEGER));
      const upcomingRows = rows.filter(item => item.status === 'upcoming')
        .sort((a,b)=>(a.open?.getTime()||Number.MAX_SAFE_INTEGER)-(b.open?.getTime()||Number.MAX_SAFE_INTEGER));

      if (openRows.length) {
        /* Keep Step 1 deliberately restrained: at most two seasonal Éditions
           are shown, plus Private occasions. */
        visible = openRows.slice(0,2);
        if (visible.length < 2 && upcomingRows.length) visible.push(upcomingRows[0]);
      } else {
        visible = upcomingRows.slice(0,2);
      }

      if (!visible.length) {
        const closed = rows.filter(item => item.status === 'closed')
          .sort((a,b)=>(b.close?.getTime()||0)-(a.close?.getTime()||0));
        if (closed.length) visible.push(closed[0]);
      }
    } else {
      const activeRow = rows.find(item => releaseMatchesActiveAllocation(item.release));
      if (activeRow) {
        visible.push(activeRow);
        const next = rows.find(item => item.index > activeRow.index);
        if (next) visible.push(next);
      } else visible = rows.slice(0,2);
    }
    return visible;
  };

  const createDraft = (seedProduct, existing = null) => {
    if (existing) {
      const clone = JSON.parse(JSON.stringify(existing));
      clone.items ||= {};
      clone.allocationLabel ||= clone.allocationName || '';
      clone.allocationWindowName ||= '';
      clone.privateWeekStart ||= '';
      clone.deliveryMode ||= '';
      clone.deliveryDate ||= '';
      clone.deliveryLabel ||= '';
      return clone;
    }
    return {
      id: `tda-${Date.now()}-${Math.random().toString(36).slice(2,8)}`,
      allocationName: '', allocationLabel: '', allocationWindowName: '', allocationType: '', deliveryWeek: '', privateWeekStart: '', 
      deliveryMode: '', deliveryDate: '', deliveryLabel: '',
      items: {}, seedProductId: seedProduct ? String(seedProduct.id) : ''
    };
  };

  const draftHasAllocation = () => !!draft?.allocationName;
  const draftAllocationComplete = () => draftHasAllocation() && (draft.allocationType !== 'private' || !!draft.deliveryWeek) && (!bookingCalendar || calendarApi.slotState(selectedSlot(), bookingCalendar) === 'available');
  const draftCount = () => countItems(draft);
  const draftDeliveryComplete = () => !!draft?.deliveryMode && (bookingCalendar
    ? (calendarApi.remaining(selectedSlot()) >= draftCount() && (draft.deliveryMode === 'standard' ? calendarApi.deliveryDates(selectedSlot(),bookingCalendar).length > 0 : calendarApi.allowedDeliveryDate(draft.deliveryDate,selectedSlot(),bookingCalendar)))
    : (draft.deliveryMode !== 'date' || !!draft.deliveryDate));
  const draftComplete = () => draftAllocationComplete() && draftCount() > 0 && !!draft.giftingReviewed && draftDeliveryComplete();

  const ensureSeedItem = () => {
    if (!draft || !draft.allocationName || !draft.seedProductId) return;
    const product = productById.get(String(draft.seedProductId));
    const variant = productVariant(product, draft.allocationName);
    const uiAvailable = draft.allocationType === 'seasonal'
      ? (!!variant?.id && seasonalDraftHasCapacity())
      : !!variant?.available;
    if (!uiAvailable) return;
    if (!draft.items[String(product.id)]) {
      draft.items[String(product.id)] = {
        productId: String(product.id), title: product.title, image: product.image,
        variantId: variant.id, unitPrice: Number(variant.price || 0), quantity: 1,
        maxQuantity: Math.max(1, Number(variant.maxQuantity || config.maxQuantity || 1))
      };
    }
  };

  const summaryText = () => {
    if (!draftHasAllocation()) return { allocation:'', creations:'', delivery:'' };
    const qty = draftCount();
    let delivery = '';
    if (draftDeliveryComplete()) {
      if (draft.deliveryMode === 'date' && draft.deliveryDate) delivery = formatHumanDate(draft.deliveryDate);
      else delivery = draft.deliveryLabel || 'Delivery arranged';
    } else if (qty) {
      delivery = 'Choose your delivery';
    }
    return {
      allocation: allocationDisplay(draft),
      creations: qty ? `${qty} item${qty === 1 ? '' : 's'} selected` : 'Choose your creations',
      delivery
    };
  };


  const thumbImageForStep = (step) => {
    const visuals = config.visuals || {};

    /* The three compact summary thumbnails mirror the three reservation stages
       exactly. Do not borrow release/review artwork here: those belong to the
       expanded journey. This keeps Theme Editor mapping literal and predictable. */
    if (step === 1) return visuals.allocation || visuals.entry || visuals.fallback || fallbackVisualUrl();
    if (step === 2) return visuals.build || visuals.fallback || fallbackVisualUrl();
    if (step === 3) return visuals.delivery || visuals.fallback || fallbackVisualUrl();
    return '';
  };

  const syncEntryThumbs = () => {
    entryThumbs.forEach((thumb, step) => {
      if (!thumb) return;
      const number = thumb.querySelector('span');
      let image = thumb.querySelector('img.tda-reservation-entry__thumb-image');
      if (!image) {
        image = document.createElement('img');
        image.className = 'tda-reservation-entry__thumb-image';
        image.alt = '';
        image.decoding = 'async';
        image.loading = 'lazy';
        thumb.appendChild(image);
      }
      const url = thumbImageForStep(step);
      if (url) {
        image.src = url;
        thumb.classList.add('has-image');
        image.hidden = false;
        if (number) number.setAttribute('aria-hidden', 'true');
      } else {
        image.removeAttribute('src');
        image.hidden = true;
        thumb.classList.remove('has-image');
        if (number) number.removeAttribute('aria-hidden');
      }
    });
  };

  const updateEntry = () => {
    const summary = summaryText();
    syncEntryThumbs();
    if (entryAllocation) entryAllocation.textContent = [summary.allocation, draftCount() > 0 ? Object.values(draft.items).filter(item => item.quantity > 0).map(item => `${item.title} × ${item.quantity}`).join(', ') : ''].filter(Boolean).join(' · ');
    if (entryCreations) entryCreations.textContent = draft?.giftingReviewed ? ([draft.gifting?.message || draft.gifting?.signature ? 'Personal message' : '', draft.gifting?.bag ? 'Signature gift bag' : ''].filter(Boolean).join(' · ') || 'No message or gift bag') : '';
    if (entryReview) entryReview.textContent = summary.delivery;

    const deliveryRow = entryRows.find(row => Number(row.dataset.tdaResEntryOpen || 0) === 3);
    const deliveryTitle = deliveryRow?.querySelector('.tda-reservation-entry__copy strong');
    if (deliveryTitle) deliveryTitle.textContent = 'Delivery';

    entryRows.forEach(row => {
      const step = Number(row.dataset.tdaResEntryOpen || 0);
      /* Private-occasion delivery is tied to the selected Atelier week, but it is
         still editable from the summary. Clicking Delivery simply returns to the
         allocation step rather than opening the seasonal date picker. */
      const unlocked = step === 1 || (step === 2 && draftAllocationComplete() && draftCount() > 0) || (step === 3 && draftAllocationComplete() && draftCount() > 0);
      row.disabled = !unlocked;
      row.classList.toggle('is-locked', !unlocked);
      row.classList.toggle('is-available', unlocked);
      const completed = (step === 1 && draftAllocationComplete() && draftCount() > 0) || (step === 2 && draft.giftingReviewed) || (step === 3 && draftDeliveryComplete());
      const action = row.querySelector('.tda-reservation-entry__action');
      if (action) {
        const isEdit = unlocked && completed;
        action.textContent = isEdit ? 'Edit' : '+';
        action.classList.toggle('is-edit', isEdit);
      }
    });

    const entryContinueButton = reservationView.querySelector('[data-tda-res-entry-continue]');
    if (entryContinueButton) {
      const finalState = draftComplete();
      if (finalState) {
        if (entryContinueButton.dataset.tdaBagPrepared !== 'true') entryContinueButton.textContent = 'Add to bag';
        prepareBagButton(entryContinueButton);
        setBagButtonLabel('Add to bag', entryContinueButton);
      } else {
        entryContinueButton.classList.remove('tda-res-bag-action', 'is-loading');
        entryContinueButton.removeAttribute('aria-busy');
        entryContinueButton.dataset.tdaBagPrepared = 'false';
        entryContinueButton.textContent = 'Continue';
      }
      entryContinueButton.disabled = false;
    }
  };

  const mobileFullReservation = () => window.matchMedia('(max-width: 749px)').matches;

  const fallbackVisualUrl = () => config.visuals?.fallback || currentProduct?.image || products[0]?.image || '';

  const releaseVisualUrl = (allocationName) => {
    if (!allocationName) return '';
    const releases = Array.isArray(config.releases) ? config.releases : [];
    const wanted = allocationKey(allocationName);
    const index = releases.findIndex(release => allocationKey(releaseAllocationName(release)) === wanted);
    if (index < 0) return '';
    return config.visuals?.[`release${index + 1}`] || '';
  };

  const visualUrlForState = (state) => {
    const visuals = config.visuals || {};
    const releaseSpecific = releaseVisualUrl(draft?.allocationName);

    if (state === 'entry') return mobileFullReservation() ? (visuals.fallback || visuals.entry || visuals.allocation || fallbackVisualUrl()) : (visuals.entry || visuals.allocation || visuals.fallback || fallbackVisualUrl());
    if (state === 'allocation') return visuals.allocation || visuals.entry || visuals.fallback || fallbackVisualUrl();
    if (state === 'waitlist') return releaseSpecific || visuals.allocation || visuals.entry || visuals.fallback || fallbackVisualUrl();
    if (state === 'build') {
      if (draft?.allocationType === 'private') return visuals.private || visuals.build || visuals.fallback || fallbackVisualUrl();
      return releaseSpecific || visuals.build || visuals.fallback || fallbackVisualUrl();
    }
    if (state === 'delivery') return visuals.delivery || releaseSpecific || visuals.build || visuals.fallback || fallbackVisualUrl();
    if (state === 'review') {
      if (draft?.allocationType === 'private') return visuals.review || visuals.private || visuals.fallback || fallbackVisualUrl();
      return visuals.review || releaseSpecific || visuals.fallback || fallbackVisualUrl();
    }
    return visuals.fallback || fallbackVisualUrl();
  };

  let visualRequestId = 0;
  const loadedVisuals = new Set();

  const preloadVisual = (url) => {
    if (!url || loadedVisuals.has(url)) return Promise.resolve(!!url);
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => { loadedVisuals.add(url); resolve(true); };
      image.onerror = () => resolve(false);
      image.src = url;
    });
  };

  /* Keep the current artwork on screen until the next one has actually loaded.
     This prevents the occasional blank stage that appeared when customers moved
     quickly between allocation, build, delivery and review. */
  const setVisual = async (state) => {
    if (!visual) return;
    visual.dataset.tdaResVisualState = state;
    const requestId = ++visualRequestId;
    const requested = visualUrlForState(state);
    const fallback = fallbackVisualUrl();
    const candidates = [...new Set([requested, fallback].filter(Boolean))];

    for (const url of candidates) {
      const ok = await preloadVisual(url);
      if (requestId !== visualRequestId) return;
      if (!ok) continue;

      const changed = visual.getAttribute('src') !== url;
      if (changed) visual.classList.remove('is-visible');
      visual.src = url;
      visualPlaceholder?.classList.add('is-hidden');
      requestAnimationFrame(() => {
        if (requestId === visualRequestId) visual.classList.add('is-visible');
      });
      return;
    }

    if (requestId !== visualRequestId) return;
    visual.classList.remove('is-visible');
    visual.removeAttribute('src');
    visualPlaceholder?.classList.remove('is-hidden');
  };

  Object.values(config.visuals || {}).filter(Boolean).forEach(url => { preloadVisual(url); });

  const showEntry = ({ collapse = false } = {}) => {
    setGiftingView(false, false);
    currentStep = 0;
    steps.hidden = true;
    entry.hidden = false;
    progress.textContent = '';
    updateEntry();
    setVisual(draftComplete() ? 'review' : 'entry');

    /* v68 — the reservation journey closes with the same visual language it
       opened with: once the final summary is ready, the full configurator
       contracts back into the narrow reservation drawer. Keep the summary
       painted before the reverse motion starts so the customer sees the
       completed reservation settle into its final state. */
    if (collapse) {
      if (mobileFullReservation()) {
        drawer.classList.remove('is-reservation-drawer', 'is-collapsing-reservation');
        drawer.classList.add('is-expanded');
      } else {
        requestAnimationFrame(() => collapseReservationExperience());
      }
    }
  };

  const showStep = (step) => {
    setGiftingView(false, false);
    const previousStep = currentStep;
    currentStep = step;
    if (step !== 2) {
      addMoreOpen = false;
      releaseStep2DrawerAnchor();
    } else if (previousStep !== 2) {
      addMoreOpen = false;
      releaseStep2DrawerAnchor();
    }
    entry.hidden = true;
    steps.hidden = false;
    stepEls.forEach(el => { el.hidden = Number(el.dataset.tdaResStep) !== step; });
    progress.textContent = `${step === 2 ? 1 : step}/3`;
    if (step === 1) {
      renderAllocations();
      setVisual('allocation');
    }
    if (step === 2) {
      renderCreations();
      setVisual('build');
    }
    if (step === 3) {
      renderDelivery();
      setVisual('delivery');
    }
  };

  const weeksFromNow = () => {
    const leadDays = Math.max(0, Number(config.privateLeadDays || 7));
    const numberOfWeeks = Math.max(4, Math.min(20, Number(config.privateWeeks || 12)));
    const first = new Date();
    first.setHours(12,0,0,0);
    first.setDate(first.getDate() + leadDays);
    const day = first.getDay();
    const toMonday = (8 - day) % 7;
    first.setDate(first.getDate() + toMonday);
    return Array.from({length:numberOfWeeks}, (_,i) => {
      const start = new Date(first); start.setDate(first.getDate() + i*7);
      const end = new Date(start); end.setDate(start.getDate()+6);
      const label = `Week of ${new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long'}).format(start)}`;
      return { value:start.toISOString().slice(0,10), label, endLabel:new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long'}).format(end) };
    });
  };

  const renderWeeks = () => {
    if (!weekList) return;
    weekList.innerHTML = weeksFromNow().map(week => `
      <button type="button" class="tda-res-week-option${draft.deliveryWeek === week.label ? ' is-selected' : ''}" data-tda-res-week="${escapeHtml(week.label)}">
        ${escapeHtml(week.label)}
      </button>`).join('');
  };

  const variantUsableForDraft = (variant) => {
    if (!variant) return false;
    if (draft?.allocationType === 'seasonal') return !!variant.id && seasonalDraftHasCapacity();
    return !!variant.available;
  };

  const startOfWeekMonday = (date) => {
    const d = new Date(date); d.setHours(12,0,0,0);
    const day = d.getDay();
    const offset = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + offset);
    return d;
  };

  const firstEligiblePrivateWeek = () => {
    const leadDays = Math.max(0, Number(config.privateLeadDays || 0));
    const d = new Date(); d.setHours(12,0,0,0);
    d.setDate(d.getDate() + leadDays);
    const monday = startOfWeekMonday(d);
    if (monday < d) monday.setDate(monday.getDate() + 7);
    return monday;
  };

  const privateHorizonEnd = () => {
    /* The private channel deliberately exposes no more than the next eight
       Atelier weeks. Earlier full weeks are skipped automatically. */
    const weeks = Math.max(1, Math.min(52, Number(config.privateWeeks) || 24));
    const start = firstEligiblePrivateWeek();
    const end = new Date(start); end.setDate(start.getDate() + (weeks - 1) * 7 + 6);
    return end;
  };

  const parsePrivateVariantWeek = (allocationName) => {
    const raw = String(allocationName || '').trim();
    if (!raw) return null;
    const base = String(config.privateAllocationName || 'Private Occasion').trim().toLowerCase();
    const lower = raw.toLowerCase();
    const looksPrivate = lower.includes(base) || /private\s+occasion/i.test(raw);
    if (!looksPrivate) return null;

    const iso = raw.match(/\b(20\d{2})-(\d{2})-(\d{2})\b/);
    if (iso) {
      const d = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]), 12,0,0,0);
      if (!Number.isNaN(d.getTime())) return d;
    }

    const human = raw.match(/\b(\d{1,2})\s+(January|February|March|April|May|June|July|August|September|October|November|December)\s+(20\d{2})\b/i);
    if (human) {
      const d = new Date(`${human[2]} ${human[1]}, ${human[3]} 12:00:00`);
      if (!Number.isNaN(d.getTime())) return d;
    }

    /* Accept labels such as "Private Occasion · W/C 21 September 2026" or
       "Private Occasion — Week commencing 21 September 2026". */
    const wc = raw.match(/(?:week\s+commencing|w\/?c)\s+(\d{1,2})\s+(January|February|March|April|May|June|July|August|September|October|November|December)(?:\s+(20\d{2}))?/i);
    if (wc) {
      const year = Number(wc[3] || new Date().getFullYear());
      const d = new Date(`${wc[2]} ${wc[1]}, ${year} 12:00:00`);
      if (!Number.isNaN(d.getTime())) return d;
    }
    return null;
  };

  const privateWeekLabel = (date) => {
    try {
      return `Week commencing ${new Intl.DateTimeFormat('en-GB', { day:'numeric', month:'long' }).format(date)}`;
    } catch (_) {
      return 'Next Atelier allocation';
    }
  };

  const sharedPrivatePool = () => {
    const rawStart = String(config.privateWeekStarting || '').trim();
    const remaining = Number(config.privateWeeklyRemaining);
    if (!rawStart || !Number.isFinite(remaining)) return null;
    const start = new Date(`${rawStart}T12:00:00`);
    if (Number.isNaN(start.getTime())) return null;
    return { start, remaining: Math.max(0, Math.floor(remaining)) };
  };

  const nearestPrivateAllocation = (product) => {
    if (!product) return null;
    if (bookingCalendar) {
      const slot = calendarApi.nearestPrivateSlot(bookingCalendar);
      return slot ? {allocationName:slot.allocationName,slotId:slot.id,startIso:slot.weekStart,start:parseCalendarDate(slot.weekStart),label:privateWeekLabel(parseCalendarDate(slot.weekStart)),remaining:calendarApi.remaining(slot)} : null;
    }

    /* Shared Atelier capacity: Shopify Flow owns one shop-level weekly counter
       for all four creations. The existing Private Occasion product variant is
       still used for checkout, while availability and the week shown to the
       customer come from the two shop metafields. */
    const sharedPool = sharedPrivatePool();
    if (sharedPool) {
      if (sharedPool.remaining < 1) return null;
      const sharedVariant = productVariant(product, config.privateAllocationName);
      if (!sharedVariant?.available) return null;
      return {
        allocationName: sharedVariant.allocation || config.privateAllocationName || 'Private Occasion',
        variant: sharedVariant,
        start: sharedPool.start,
        startIso: isoLocal(sharedPool.start),
        label: privateWeekLabel(sharedPool.start),
        legacy: true,
        sharedCapacity: true,
        remaining: sharedPool.remaining
      };
    }

    /* Safe fallback for stores that have not yet initialised the shop metafields:
       keep the previous dated-variant rolling behaviour intact. */
    const earliest = firstEligiblePrivateWeek();
    const horizon = privateHorizonEnd();
    const dated = (product.variants || [])
      .map(variant => ({ variant, start: parsePrivateVariantWeek(variant.allocation) }))
      .filter(item => item.start)
      .sort((a,b) => a.start - b.start);

    if (dated.length) {
      const match = dated.find(item => item.variant?.available && item.start >= earliest && item.start <= horizon);
      if (!match) return null;
      return {
        allocationName: match.variant.allocation,
        variant: match.variant,
        start: match.start,
        startIso: isoLocal(match.start),
        label: privateWeekLabel(match.start),
        legacy: false
      };
    }

    /* Launch fallback: until week-dated Shopify variants are added, the existing
       Private Occasion variant behaves as the nearest rolling Atelier allocation. */
    const legacy = productVariant(product, config.privateAllocationName);
    if (!legacy?.available) return null;
    return {
      allocationName: legacy.allocation || config.privateAllocationName || 'Private Occasion',
      variant: legacy,
      start: earliest,
      startIso: isoLocal(earliest),
      label: privateWeekLabel(earliest),
      legacy: true
    };
  };

  const ensurePrivateAvailabilityView = () => {
    if (privateAvailabilityView || !step1Content) return privateAvailabilityView;
    privateAvailabilityView = document.createElement('div');
    privateAvailabilityView.className = 'tda-res-private-screen';
    privateAvailabilityView.setAttribute('data-tda-private-screen','');
    privateAvailabilityView.hidden = true;
    if (allocationList?.nextSibling) step1Content.insertBefore(privateAvailabilityView, allocationList.nextSibling);
    else step1Content.appendChild(privateAvailabilityView);
    return privateAvailabilityView;
  };

  const resetStep1StandardView = () => {
    privateAvailabilityActive = false;
    if (step1Heading) step1Heading.textContent = 'Choose your occasion';
    if (step1Copy) step1Copy.textContent = 'Choose the moment that suits your occasion.';
    if (privateAvailabilityView) privateAvailabilityView.hidden = true;
    if (allocationList) {
      allocationList.hidden = false;
      allocationList.style.removeProperty('display');
    }
    if (weekPicker) {
      weekPicker.hidden = true;
      weekPicker.style.removeProperty('display');
    }
    const continueButton = reservationView.querySelector('[data-tda-res-next="2"]');
    if (continueButton) {
      delete continueButton.dataset.tdaPrivateReserveWeek;
      continueButton.textContent = 'Continue';
    }
  };

  /* Private occasions use a deliberately hidden rolling calendar. The customer
     never chooses between multiple weeks: we surface only the nearest available
     Atelier allocation inside the booking horizon. */
  const showPrivateAvailabilityScreen = () => {
    if (!currentProduct) return;
    parkWaitlist();
    privateAvailabilityActive = true;
    const view = ensurePrivateAvailabilityView();
    if (!view) return;

    if (step1Heading) step1Heading.textContent = 'Atelier availability';
    if (step1Copy) step1Copy.textContent = 'The nearest available private allocation.';

    if (allocationList) {
      allocationList.hidden = true;
      allocationList.style.setProperty('display', 'none', 'important');
    }
    if (weekPicker) {
      weekPicker.hidden = true;
      weekPicker.style.setProperty('display', 'none', 'important');
    }
    view.hidden = false;

    const option = nearestPrivateAllocation(currentProduct);
    const continueButton = reservationView.querySelector('[data-tda-res-next="2"]');

    if (option) {
      selectPrivateAllocation(option, { render:false });
      view.innerHTML = `
        <div class="tda-res-private-card tda-res-private-nearest">
          <span class="tda-res-private-card__eyebrow">Atelier availability</span>
          <strong>${escapeHtml(option.label)}</strong>
          <p>A limited number of creations are available within this Atelier allocation.</p>
        </div>`;
      if (continueButton) {
        continueButton.textContent = 'Reserve this allocation';
        continueButton.disabled = false;
      }
    } else {
      draft.deliveryWeek = '';
      draft.privateWeekStart = '';
      draft.deliveryMode = '';
      draft.deliveryDate = '';
      draft.deliveryLabel = '';
      view.innerHTML = `
        <div class="tda-res-private-screen__next" style="margin-top:0;padding-top:0;border-top:0">
          <span class="tda-res-private-screen__eyebrow">Atelier availability</span>
          <h3>Reservations are currently unavailable</h3>
          <p>Register your interest and we’ll let you know when the next private allocation opens.</p>
          <button type="button" class="tda-res-private-card__action" data-tda-private-register>Register your interest</button>
        </div>`;
      if (continueButton) {
        continueButton.textContent = 'Continue';
        continueButton.disabled = true;
      }
    }
  };

  const selectPrivateAllocation = (option, { render = true } = {}) => {
    if (!draft || !option) return;
    const changed = draft.allocationName !== option.allocationName || draft.privateWeekStart !== option.startIso;
    if (bookingCalendar) draft.slotId = option.slotId;
    draft.allocationName = option.allocationName;
    draft.allocationLabel = 'Private occasions';
    draft.allocationWindowName = '';
    draft.allocationType = 'private';
    draft.privateWeekStart = option.startIso;
    draft.deliveryWeek = option.label;
    if (changed) draft.items = {};
    draft.deliveryMode = 'standard';
    draft.deliveryDate = '';
    /* Review stays quiet: the allocation row already says Private occasions. */
    draft.deliveryLabel = option.label;
    ensureSeedItem();
    updateEntry();
    if (render) showPrivateAvailabilityScreen();
  };

  const renderCalendarAllocations = () => {
    if (step1Heading) step1Heading.textContent = 'Choose your occasion';
    const number=step1Content?.querySelector(':scope > .tda-reservation-step__label');
    if(number){number.hidden=false;number.textContent='1/3';number.style.removeProperty('display');}
    if (step1Copy) step1Copy.textContent = 'Choose the moment that suits your occasion.';
    const slots = calendarApi.availableSlots(bookingCalendar);
    const privateSlots = slots.filter(slot => slot.kind === 'private' && calendarApi.remaining(slot)>0);
    const privateSelected = draft?.allocationType === 'private';
    const row = slot => {
      const available = calendarApi.slotState(slot, bookingCalendar) === 'available';
      const selected = draft?.slotId === slot.id;
      const range = formatDeliveryRange(parseCalendarDate(slot.deliveryFrom), parseCalendarDate(slot.deliveryUntil));
      return `<div class="tda-res-allocation-option-wrap"><button type="button" class="tda-res-allocation-option${selected ? ' is-selected' : ''}${available ? '' : ' is-waitlist'}" data-tda-res-allocation="${escapeHtml(slot.allocationName)}" data-tda-slot-id="${escapeHtml(slot.id)}" data-tda-res-allocation-type="seasonal" data-tda-res-selectable="${available}" aria-pressed="${selected}"><span class="tda-res-allocation-option__copy"><strong>${escapeHtml(slot.title)}</strong><small>Delivery ${escapeHtml(range)}</small></span><span class="tda-res-allocation-option__action">${available ? 'Select' : 'Join the waiting list'}</span></button></div>`;
    };
    allocationList.innerHTML = slots.filter(slot => slot.kind === 'seasonal').map(row).join('') + (privateSlots.length ? `
      <div class="tda-res-allocation-option-wrap">
        <button type="button" class="tda-res-allocation-option${privateSelected ? ' is-selected' : ''}" data-tda-res-allocation="Private Occasion" data-tda-res-allocation-type="private" data-tda-res-selectable="true" aria-expanded="${privateSelected}">
          <span class="tda-res-allocation-option__copy"><strong>Private occasions</strong><small>For an occasion of your own</small></span><span class="tda-res-allocation-option__action">Select</span>
        </button>

      </div>` : '');
    const continueButton = reservationView.querySelector('[data-tda-res-next="2"]');
    if (continueButton) continueButton.disabled = !selectedSlot() || calendarApi.slotState(selectedSlot(), bookingCalendar) !== 'available';
  };

  const selectCalendarSlot = slot => {
    if (!draft || !slot) return;
    parkWaitlist();
    const changed = draft.slotId !== slot.id;
    draft.slotId = slot.id;
    draft.allocationName = slot.allocationName;
    draft.allocationLabel = slot.title;
    draft.allocationWindowName = '';
    draft.allocationType = slot.kind;
    draft.privateWeekStart = slot.weekStart || '';
    draft.deliveryWeek = slot.kind === 'private' ? privateWeekLabel(parseCalendarDate(slot.weekStart)) : '';
    if (changed) {
      draft.items = {};
      draft.deliveryMode = '';
      draft.deliveryDate = '';
      draft.deliveryLabel = slot.kind === 'private' ? '' : formatDeliveryRange(parseCalendarDate(slot.deliveryFrom), parseCalendarDate(slot.deliveryUntil));
    }
    ensureSeedItem();
    renderAllocations();
    updateEntry();
  };

  const renderAllocations = async () => {
    if (!allocationList || !currentProduct) return;
    parkWaitlist();
    resetStep1StandardView();
    if (step1Footer) step1Footer.hidden = false;

    if (bookingCalendar) {
      if (!bookingCalendar.preview && Date.now()-calendarCheckedAt>15000) {
        const request=++calendarRenderRequest;
        // Retain the occasion cards while revalidating rather than flashing a loading screen.
        renderCalendarAllocations();
        allocationList.setAttribute('aria-busy', 'true');
        allocationList.querySelectorAll('button').forEach(button => { button.disabled = true; });
        const next=reservationView.querySelector('[data-tda-res-next="2"]');
        if(next)next.disabled=true;
        try { await refreshBookingCalendar(); }
        catch {
          allocationList.removeAttribute('aria-busy');
          if(request===calendarRenderRequest)allocationList.innerHTML='<p class="tda-res-date-note" role="status">Please try again to check availability.</p><button type="button" class="tda-reservation-primary" data-tda-calendar-retry>Try again</button>';
          return;
        }
        if(request!==calendarRenderRequest)return;
        allocationList.removeAttribute('aria-busy');
      }
      renderCalendarAllocations(); return;
    }
    const options = scheduleOptions(currentProduct);
    const html = [];
    options.forEach((item, index) => {
      const variant = item.variant;
      const allocationName = item.allocationName || releaseAllocationName(item.release);
      const windowName = item.allocation?.name || '';
      const openState = item.status === 'open' || (item.status === 'unscheduled' && index === 0);
      const isActiveRelease = releaseMatchesActiveAllocation(item.release);
      const hasCapacity = releaseCapacityRemaining() > 0;
      const selectable = !!variant?.id && openState && isActiveRelease && hasCapacity;
      const action = selectable ? 'Select' : 'Join the List';
      const isMultiAllocationEdition = releaseAllocations(item.release).length > 1;
      const windowTitle = allocationWindowTitle(windowName);
      let meta = item.allocation?.period || '';

      if (item.status === 'upcoming' && item.open) {
        meta = isMultiAllocationEdition && windowTitle
          ? `${windowTitle} allocation opens ${formatDayMonth(item.open, false)}`
          : `Opens ${formatDate(item.open)}`;
      } else if (item.status === 'open' && isMultiAllocationEdition && windowTitle) {
        meta = item.allocation?.period ? `${windowTitle} allocation · ${item.allocation.period}` : `${windowTitle} allocation`;
      } else if (item.status === 'closed') {
        meta = isMultiAllocationEdition && windowTitle ? `${windowTitle} allocation closed` : 'Reservations closed';
      }

      const selected = draft.allocationType === 'seasonal'
        && allocationKey(draft.allocationName) === allocationKey(allocationName)
        && (!draft.allocationWindowName || allocationKey(draft.allocationWindowName) === allocationKey(windowName));
      const waitlistReason = !openState ? item.status : (!isActiveRelease ? 'not-active' : (!hasCapacity ? 'full' : 'unavailable'));
      const nextWindow = item.status === 'open' && isMultiAllocationEdition
        ? nextUpcomingAllocationForRelease(item.release, item.allocation)
        : null;
      const nextWindowTitle = allocationWindowTitle(nextWindow?.allocation?.name || '');
      const nextWindowMeta = nextWindow?.open && nextWindowTitle
        ? `${nextWindowTitle} allocation opens ${formatDayMonth(nextWindow.open, false)}`
        : '';
      const nextWindowHtml = nextWindowMeta ? `
        <button type="button" class="tda-res-allocation-next"
          data-tda-res-next-allocation-waitlist
          data-tda-res-next-edition="${escapeHtml(allocationName)}"
          data-tda-res-next-window="${escapeHtml(nextWindow.allocation?.name || '')}"
          aria-expanded="false">
          <span>${escapeHtml(nextWindowMeta)}</span>
          <span class="tda-res-allocation-next__symbol" aria-hidden="true"></span>
        </button>` : '';

      html.push(`
        <div class="tda-res-allocation-option-wrap">
          <button type="button" class="tda-res-allocation-option${selected ? ' is-selected' : ''}${selectable ? '' : ' is-waitlist'}"
            data-tda-res-allocation="${escapeHtml(allocationName)}"
            data-tda-res-allocation-label="${escapeHtml(item.release.name)}"
            data-tda-res-window-name="${escapeHtml(windowName)}"
            data-tda-res-allocation-type="seasonal"
            data-tda-res-selectable="${selectable ? 'true':'false'}" data-tda-res-waitlist-reason="${escapeHtml(waitlistReason)}">
            <span class="tda-res-allocation-option__copy"><strong>${escapeHtml(item.release.name)}</strong><small>${escapeHtml(meta)}</small></span>
            <span class="tda-res-allocation-option__action">${action}</span>
          </button>
          ${nextWindowHtml}
        </div>`);
    });

    /* Private occasions now live in the allocation list itself. We resolve the
       rolling calendar silently and show only the nearest week with capacity.
       There is no intermediate "Atelier availability" screen. */
    const privateOption = nearestPrivateAllocation(currentProduct);
    const privateSelected = draft.allocationType === 'private' && !!draft.deliveryWeek;
    const privateSelectable = !!privateOption;
    /* Private occasions are a rolling weekly channel, not a waitlist channel.
       The customer never sees sold-out weeks: nearestPrivateAllocation() scans
       forward through the configured eight-week horizon and returns the first
       week with capacity. Only when that whole horizon is unavailable do we
       present the channel as closed. */
    const privateMeta = 'Limited weekly availability';
    const privateAction = privateSelectable ? 'Select' : 'Reservations closed';
    html.push(`
      <button type="button" class="tda-res-allocation-option${privateSelected ? ' is-selected' : ''}${privateSelectable ? '' : ' is-closed'}"
        data-tda-res-allocation="${escapeHtml(config.privateAllocationName || 'Private Occasion')}" data-tda-res-allocation-type="private"
        data-tda-res-selectable="${privateSelectable ? 'true':'false'}" aria-disabled="${privateSelectable ? 'false':'true'}">
        <span class="tda-res-allocation-option__copy"><strong>Private occasions</strong><small>${escapeHtml(privateMeta)}</small></span>
        <span class="tda-res-allocation-option__action">${privateAction}</span>
      </button>`);

    allocationList.innerHTML = html.join('');

    const continueButton = reservationView.querySelector('[data-tda-res-next="2"]');
    if (continueButton) continueButton.disabled = !draftHasAllocation();
  };

  const setAllocation = (name, type, label = '', windowName = '') => {
    if (!draft) return;
    const changed = draft.allocationName !== name || allocationKey(draft.allocationWindowName) !== allocationKey(windowName);
    draft.allocationName = name;
    draft.allocationLabel = label || name;
    draft.allocationWindowName = type === 'seasonal' ? (windowName || '') : '';
    draft.allocationType = type;
    draft.deliveryWeek = '';
    draft.privateWeekStart = '';
    if (changed) {
      draft.items = {};
      draft.deliveryMode = '';
      draft.deliveryDate = '';
      draft.deliveryLabel = '';
    }
    if (type !== 'private' || draft.deliveryWeek) ensureSeedItem();
    renderAllocations();
    updateEntry();
  };

  const openWaitlist = (allocationName, reason, allocationButton = null, windowName = '', drawerAnchor = null) => {
    if (!waitlist) return;
    prepareWaitlistMicroFields();
    parkWaitlist();
    anchorStep1ForInlineDrawer();
    if (weekPicker) weekPicker.hidden = true;
    if (step1Footer) step1Footer.hidden = false;
    allocationList.hidden = false;

    waitlist.classList.remove('is-open');
    waitlist.hidden = false;
    waitlist.classList.add('is-inline-drawer', 'tda-res-inline-drawer');
    waitlist.classList.toggle('is-standard-waitlist', !drawerAnchor);
    waitlist.setAttribute('aria-hidden','false');
    const anchor = drawerAnchor || allocationButton;
    if (anchor?.parentNode) anchor.insertAdjacentElement('afterend', waitlist);
    if (drawerAnchor?.matches?.('[data-tda-res-next-allocation-waitlist]')) {
      activeWaitlistTrigger = drawerAnchor;
      activeWaitlistTrigger.classList.add('is-open');
      activeWaitlistTrigger.setAttribute('aria-expanded', 'true');
    }
    /* Match the Gift Card drawer: paint the fully-collapsed state first, then open on the next paint. */
    void waitlist.offsetHeight;

    if (waitlistCopy) {
      const windowTitle = allocationWindowTitle(windowName);
      waitlistCopy.textContent = windowTitle
        ? `Join the list to be informed when the ${windowTitle} allocation opens.`
        : 'Be among the first to know when the next allocation opens.';
    }
    if (bookingCalendar) {
      const slot = bookingCalendar.slots.find(item=>item.id === allocationButton?.dataset.tdaSlotId) || selectedSlot();
      if (slot) {
        if (waitlistCopy) waitlistCopy.textContent = 'Tell us which creations you would like. We’ll be in touch if a place becomes available.';
        window.TDAReservationWaitlist?.open(waitlist.querySelector('[data-tda-waitlist-form]'),{slot,calendar:bookingCalendar,products,seedProduct:currentProduct});
      }
    }
    setVisual('waitlist');
    if (waitlistTags) {
      const windowTag = windowName ? `,tda-window-${slugify(windowName)}` : '';
      waitlistTags.value = `newsletter,tda-waitlist,tda-box-${slugify(currentProduct?.title)},tda-allocation-${slugify(allocationName)}${windowTag}`;
    }

    allocationList.querySelectorAll('.tda-res-allocation-option').forEach(btn => btn.classList.toggle('is-selected', btn === allocationButton));
    const continueButton = reservationView.querySelector('[data-tda-res-next="2"]');
    if (continueButton) continueButton.disabled = true;
    requestAnimationFrame(() => requestAnimationFrame(() => waitlist.classList.add('is-open')));
  };

  const syncAvailabilityNote = () => {
    const note = creationsList?.querySelector('[data-tda-res-availability-note]');
    if (!note) return;
    const capacity = releaseCapacityRemaining();
    note.hidden = !((bookingCalendar || draft?.allocationType === 'seasonal') && capacity > 0 && draftCount() >= capacity);
  };

  const renderCreations = () => {
    if (!creationsList || !draftAllocationComplete()) return;
    ensureSeedItem();

    const buildCopy = reservationView.querySelector('[data-tda-res-build-copy]');
    if (buildCopy) {
      buildCopy.textContent = '';
      buildCopy.hidden = true;
    }

    /* Keep the original (seed) creation in the primary row. Any creations added
       through “Include another creation” stay in that inline drawer even after
       their quantity rises above zero, so customers can adjust them there without
       the row jumping into the primary selection. */
    const seedProduct = productById.get(String(draft.seedProductId));
    const selectedProducts = seedProduct && Number(draft.items[String(seedProduct.id)]?.quantity || 0) > 0
      ? [seedProduct]
      : [];
    const selectedHtml = selectedProducts.map(product => {
      const variant = productVariant(product, draft.allocationName);
      const saved = draft.items[String(product.id)];
      const quantity = Number(saved?.quantity || 0);
      const baseMax = Math.max(1, Number(variant?.maxQuantity || config.maxQuantity || 1));
      const otherSelected = Math.max(0, draftCount() - quantity);
      const capacityMax = (bookingCalendar || draft.allocationType === 'seasonal')
        ? Math.max(0, releaseCapacityRemaining() - otherSelected)
        : baseMax;
      const max = (bookingCalendar || draft.allocationType === 'seasonal') ? Math.min(baseMax, capacityMax) : baseMax;
      const price = Number(variant?.price || product.price || 0);
      return `
        <div class="tda-res-creation-row" data-tda-res-product-row="${escapeHtml(product.id)}">
          <div class="tda-res-creation-row__image">${product.image ? `<img src="${escapeHtml(product.image)}" alt="">` : ''}</div>
          <div class="tda-res-creation-row__copy"><strong>${escapeHtml(product.title)}</strong><small>${formatMoney(price)}</small></div>
          <div class="tda-res-quantity" aria-label="Quantity for ${escapeHtml(product.title)}">
            <button type="button" data-tda-res-qty-minus="${escapeHtml(product.id)}" ${quantity <= 0 ? 'disabled':''}>−</button>
            <span>${quantity}</span>
            <button type="button" data-tda-res-qty-plus="${escapeHtml(product.id)}" ${quantity >= max ? 'disabled':''}>+</button>
          </div>
        </div>`;
    }).join('');

    /* v55 — Step 2 stays single-purpose. For Private occasions, surface the
       automatically resolved Atelier week once, quietly, immediately above the
       creation rather than creating another screen or decision. */
    const privateAvailabilityLine = !bookingCalendar && draft.allocationType === 'private' && draft.deliveryWeek
      ? `<p class="tda-res-private-availability-line" style="margin:0 0 12px;font-family:var(--font-body-family, 'Helvetica Neue', Helvetica, Arial, sans-serif);font-size:10px;font-weight:400;line-height:1.35;color:#6b655f;letter-spacing:0;"><strong style="font-weight:500;color:#171717;">Availability:</strong> ${escapeHtml(draft.deliveryWeek)}</p>`
      : '';
    const additionalProducts = products.filter(product => {
      if (String(product.id) === String(draft.seedProductId)) return false;
      const variant = productVariant(product, draft.allocationName);
      return variantUsableForDraft(variant);
    });

    const additionalHtml = additionalProducts.map(product => {
      const variant = productVariant(product, draft.allocationName);
      const price = Number(variant?.price || product.price || 0);
      const quantity = Number(draft.items[String(product.id)]?.quantity || 0);
      const baseMax = Math.max(1, Number(variant?.maxQuantity || config.maxQuantity || 1));
      const otherSelected = Math.max(0, draftCount() - quantity);
      const capacityMax = (bookingCalendar || draft.allocationType === 'seasonal')
        ? Math.max(0, releaseCapacityRemaining() - otherSelected)
        : baseMax;
      const max = (bookingCalendar || draft.allocationType === 'seasonal') ? Math.min(baseMax, capacityMax) : baseMax;
      return `
        <div class="tda-res-creation-row tda-res-add-creation-row" data-tda-res-add-row="${escapeHtml(product.id)}">
          <div class="tda-res-creation-row__image">${product.image ? `<img src="${escapeHtml(product.image)}" alt="">` : ''}</div>
          <div class="tda-res-creation-row__copy">
            <strong>${escapeHtml(product.title)}</strong>
            <small>${formatMoney(price)}</small>
          </div>
          <div class="tda-res-quantity" aria-label="Quantity for ${escapeHtml(product.title)}">
            <button type="button" data-tda-res-qty-minus="${escapeHtml(product.id)}" ${quantity <= 0 ? 'disabled':''} aria-label="Decrease ${escapeHtml(product.title)}">−</button>
            <span>${quantity}</span>
            <button type="button" data-tda-res-qty-plus="${escapeHtml(product.id)}" ${quantity >= max ? 'disabled':''} aria-label="Increase ${escapeHtml(product.title)}">+</button>
          </div>
        </div>`;
    }).join('');

    const addMore = additionalProducts.length ? `
      <div class="tda-res-add-more">
        <button type="button"
          class="tda-res-add-more__toggle"
          data-tda-res-add-more-toggle
          aria-expanded="false">
          <span>Include another creation</span>
          <span class="tda-res-add-more__mark" aria-hidden="true"></span>
        </button>

        <div class="tda-res-add-more__drawer tda-res-inline-drawer"
          data-tda-res-add-more-drawer
          aria-hidden="true">
          <div class="tda-res-inline-drawer__inner">
            <div class="tda-res-add-more__options">
              ${additionalHtml}
            </div>
          </div>
        </div>
      </div>` : '';

    creationsList.innerHTML = `${privateAvailabilityLine}<div class="tda-res-selected-creations">${selectedHtml}</div><p class="tda-res-availability-note" data-tda-res-availability-note role="status" hidden>You’ve reached the available quantity for this occasion.</p>${addMore}`;

    /* renderCreations replaces the rows after every quantity change. Preserve an
       open “Include another creation” drawer so + / − adjustments happen in place
       instead of collapsing the drawer or moving the chosen creation elsewhere. */
    if (addMoreOpen) {
      const toggle = creationsList.querySelector('[data-tda-res-add-more-toggle]');
      const drawerEl = creationsList.querySelector('[data-tda-res-add-more-drawer]');
      if (toggle && drawerEl) {
        anchorStep2ForInlineDrawer();
        toggle.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        drawerEl.classList.add('is-open');
        drawerEl.setAttribute('aria-hidden', 'false');
      } else {
        addMoreOpen = false;
        releaseStep2DrawerAnchor();
      }
    }

    const next = reservationView.querySelector('[data-tda-res-next="3"]');
    if (next) next.disabled = draftCount() < 1;
    syncGiftChoice();
    syncAvailabilityNote();
    updateEntry();
  };

  const syncCreationQuantityControls = () => {
    if (!creationsList || !draftAllocationComplete()) return;

    creationsList.querySelectorAll('[data-tda-res-product-row], [data-tda-res-add-row]').forEach(row => {
      const productId = row.dataset.tdaResProductRow || row.dataset.tdaResAddRow || '';
      const product = productById.get(String(productId));
      const variant = productVariant(product, draft?.allocationName);
      if (!product || !variantUsableForDraft(variant)) return;

      const quantity = Number(draft.items[String(productId)]?.quantity || 0);
      const baseMax = Math.max(1, Number(variant.maxQuantity || config.maxQuantity || 1));
      const otherSelected = Math.max(0, draftCount() - quantity);
      const capacityMax = (bookingCalendar || draft.allocationType === 'seasonal')
        ? Math.max(0, releaseCapacityRemaining() - otherSelected)
        : baseMax;
      const max = (bookingCalendar || draft.allocationType === 'seasonal') ? Math.min(baseMax, capacityMax) : baseMax;

      const quantityWrap = row.querySelector('.tda-res-quantity');
      const value = quantityWrap?.querySelector('span');
      const minusButton = row.querySelector('[data-tda-res-qty-minus]');
      const plusButton = row.querySelector('[data-tda-res-qty-plus]');

      if (value) value.textContent = String(quantity);
      if (minusButton) minusButton.disabled = quantity <= 0;
      if (plusButton) plusButton.disabled = quantity >= max;
    });

    const nextButton = reservationView.querySelector('[data-tda-res-next="3"]');
    if (nextButton) nextButton.disabled = draftCount() < 1;
    syncAvailabilityNote();
    updateEntry();
  };

  const changeQuantity = (productId, delta) => {
    const product = productById.get(String(productId));
    const variant = productVariant(product, draft?.allocationName);
    if (!draft || !product || !variantUsableForDraft(variant)) return;
    const baseMax = Math.max(1, Number(variant.maxQuantity || config.maxQuantity || 1));
    const current = Number(draft.items[String(productId)]?.quantity || 0);
    const otherSelected = Math.max(0, draftCount() - current);
    const capacityMax = (bookingCalendar || draft.allocationType === 'seasonal')
      ? Math.max(0, releaseCapacityRemaining() - otherSelected)
      : baseMax;
    const max = (bookingCalendar || draft.allocationType === 'seasonal') ? Math.min(baseMax, capacityMax) : baseMax;
    const next = Math.max(0, Math.min(max, current + delta));
    if (next < 1) delete draft.items[String(productId)];
    else draft.items[String(productId)] = {
      productId:String(product.id), title:product.title, image:product.image,
      variantId:variant.id, unitPrice:Number(variant.price || 0), quantity:next, maxQuantity:max
    };

    /* Additional creation rows must remain physically mounted while their quantity
       changes. Rebuilding creationsList replaced the open drawer with a new, closed
       element and then reopened it, which caused the visible close/open flash. */
    if (addMoreOpen) {
      /* While the drawer is open, update every Step 2 quantity control in place —
         including the primary creation. Rebuilding the section would replace the
         open drawer and create the visible close/reopen jump. */
      syncCreationQuantityControls();
      return;
    }

    renderCreations();
  };

  const syncDeliveryDateField = () => {
    const field = reservationView.querySelector('[data-tda-res-delivery-date-field]');
    const input = reservationView.querySelector('[data-tda-res-delivery-date]');
    if (!field || !input) return;
    const active = document.activeElement === input || !!input.value;
    field.classList.toggle('is-active', active);
    field.classList.toggle('is-valid', !!input.value && input.checkValidity());
  };

  const syncDeliveryControls = () => {
    const rules = deliveryRules();
    const modeButtons = reservationView.querySelectorAll('[data-tda-res-delivery-mode]');
    modeButtons.forEach(button => {
      const selected = button.dataset.tdaResDeliveryMode === draft?.deliveryMode;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    const dateDrawer = reservationView.querySelector('[data-tda-res-delivery-date-drawer]');
    const dateInput = reservationView.querySelector('[data-tda-res-delivery-date]');
    const dateOpen = draft?.deliveryMode === 'date' && (!bookingCalendar || deliveryCalendarOpen);
    if (bookingCalendar) {
      const selectedDate = reservationView.querySelector('[data-tda-res-selected-date]');
      if (selectedDate) selectedDate.textContent = draft?.deliveryMode === 'date' && draft.deliveryDate ? formatHumanDate(draft.deliveryDate) : '';
      const preferred = reservationView.querySelector('[data-tda-res-delivery-mode="date"]');
      preferred?.setAttribute('aria-expanded', String(dateOpen));
    }
    dateDrawer?.classList.toggle('is-open', dateOpen);
    dateDrawer?.setAttribute('aria-hidden', dateOpen ? 'false' : 'true');
    if (dateDrawer) dateDrawer.inert = !dateOpen;
    if (dateInput) {
      dateInput.disabled = !dateOpen;
      dateInput.required = dateOpen;
      dateInput.min = rules.min || '';
      if (rules.max) dateInput.max = rules.max; else dateInput.removeAttribute('max');
      dateInput.value = draft?.deliveryDate || '';
    }
    syncDeliveryDateField();
    const complete = reservationView.querySelector('[data-tda-res-delivery-complete]');
    if (complete) complete.disabled = !draftDeliveryComplete();
  };

  const usePrivateDeliverySlot = slot => {
    if(!slot || !draft)return;
    draft.slotId=slot.id;draft.privateWeekStart=slot.weekStart;draft.deliveryWeek=privateWeekLabel(parseCalendarDate(slot.weekStart));
    for(const item of Object.values(draft.items)){const variant=slot.variants[String(item.productId)];if(variant){item.variantId=variant.id;item.unitPrice=variant.price;}}
  };

  const renderDelivery = () => {
    if (!draft || !draftAllocationComplete() || draftCount() < 1) return;
    const step3 = stepEls.find(el => Number(el.dataset.tdaResStep) === 3);
    if (!step3) return;
    const content = step3.querySelector('.tda-reservation-step__content');
    const footer = step3.querySelector('.tda-reservation-step__footer');
    if (!content || !footer) return;

    deliveryPicker?.close();
    deliveryPicker = null;
    deliveryCalendarOpen = false;
    const rules = deliveryRules();
    const privateCalendar=bookingCalendar && draft.allocationType==='private';
    if(privateCalendar && draft.deliveryMode!=='date') usePrivateDeliverySlot(calendarApi.earliestPrivateSlot(bookingCalendar,Math.max(1,draftCount())));
    if(bookingCalendar && draft.deliveryDate && !rules.dates.includes(draft.deliveryDate)) draft.deliveryDate='';
    if (!draft.deliveryMode) {
      draft.deliveryMode = 'standard';
      draft.deliveryLabel = rules.summaryLabel;
      draft.deliveryDate = '';
    }

    content.classList.add('tda-reservation-delivery-content');
    content.innerHTML = `
      <p class="tda-reservation-step__label">3/3</p>
      <h2>Arrange your delivery</h2>
      <div class="tda-res-delivery-stack">
        <fieldset class="tda-res-delivery-choice-group">
          <legend class="tda-res-delivery-field-label">When should it arrive?</legend>
          <div class="tda-res-delivery-choice-grid">
            <button type="button" class="tda-res-delivery-choice${draft.deliveryMode === 'standard' ? ' is-selected' : ''}" data-tda-res-delivery-mode="standard" aria-pressed="${draft.deliveryMode === 'standard' ? 'true':'false'}">
              <span class="tda-res-delivery-radio"></span>
              <span class="tda-res-delivery-choice__copy">
                <span>${escapeHtml(rules.standardLabel)}</span>
                ${rules.weekLabel ? `<small>${escapeHtml(rules.weekLabel)}</small>` : ''}
              </span>
            </button>
            <button type="button" class="tda-res-delivery-choice${draft.deliveryMode === 'date' ? ' is-selected' : ''}" data-tda-res-delivery-mode="date" aria-pressed="${draft.deliveryMode === 'date' ? 'true':'false'}">
              <span class="tda-res-delivery-radio"></span>
              <span class="tda-res-delivery-choice__copy">
                <span>${privateCalendar?'Choose a future delivery date':'Choose a preferred arrival date'}</span>
                ${!privateCalendar && rules.rangeLabel ? `<small>${escapeHtml(rules.rangeLabel)}</small>` : ''}
                ${bookingCalendar ? '<small data-tda-res-selected-date></small>' : ''}
              </span>
            </button>
          </div>
        </fieldset>
        <div class="tda-res-delivery-drawer" data-tda-res-delivery-date-drawer aria-hidden="true">
          <div class="tda-res-delivery-drawer__inner">
            ${bookingCalendar ? '<p class="tda-res-date-note tda-res-preferred-guidance">We’ll do our best to deliver around your preferred date.</p>' : ''}
            <div class="tda-res-delivery-date-field" data-tda-res-delivery-date-field>
              <div class="tda-res-delivery-date-box">
                <label for="TdaReservationDeliveryDate-${root.id}">Preferred arrival date</label>
                <div class="tda-res-delivery-date-control">
${bookingCalendar ? `<input type="hidden" data-tda-res-delivery-date value="${escapeHtml(draft.deliveryDate||'')}"><div class="tda-date-picker" data-tda-date-picker></div>` : `<input id="TdaReservationDeliveryDate-${root.id}" type="date" data-tda-res-delivery-date value="${escapeHtml(draft.deliveryDate||'')}" min="${rules.min}" max="${rules.max}">`}
                  <span class="tda-res-delivery-valid-tick" aria-hidden="true"></span>
                </div>
                <span class="tda-res-delivery-input-line" aria-hidden="true"></span>
              </div>
            </div>
          </div>
        </div>
      </div>`;

    footer.className = 'tda-reservation-step__footer tda-reservation-step__footer--delivery';
    footer.innerHTML = `
      <button type="button" class="tda-reservation-back" data-tda-res-back="2">Back</button>
      <button type="button" class="tda-reservation-primary" data-tda-res-delivery-complete ${draftDeliveryComplete() ? '' : 'disabled'}>Continue</button>`;
    if(bookingCalendar){
      const field=content.querySelector('[data-tda-res-delivery-date-field]');
      field.classList.add('tda-res-calendar-field');
      deliveryPicker=calendarApi.mountPicker(content.querySelector('[data-tda-date-picker]'),{dates:rules.dates,value:draft.deliveryDate,
        trigger:content.querySelector('[data-tda-res-delivery-mode="date"]'),
        onOpenChange:open=>{deliveryCalendarOpen=open;syncDeliveryControls();},
        onChange:date=>{
        if(privateCalendar){
          const slot=calendarApi.availableSlots(bookingCalendar).find(s=>s.kind==='private' && calendarApi.remaining(s)>=draftCount() && calendarApi.allowedDeliveryDate(date,s,bookingCalendar));
          if(!slot)return;
          usePrivateDeliverySlot(slot);
        }
        draft.deliveryDate=date;draft.deliveryLabel=formatHumanDate(date);syncDeliveryControls();updateEntry();
      }});
      if(draft.deliveryMode==='date')requestAnimationFrame(()=>deliveryPicker?.open());
    }
    syncDeliveryControls();
    updateEntry();
  };

  const completeDelivery = () => {
    if (!draftDeliveryComplete()) return;
    const rules = deliveryRules();
    if (draft.deliveryMode === 'standard') {
      draft.deliveryDate = '';
      draft.deliveryLabel = rules.summaryLabel;
    } else if (draft.deliveryMode === 'date') {
      draft.deliveryLabel = draft.deliveryDate ? formatHumanDate(draft.deliveryDate) : '';
    }
    updateEntry();
    showEntry({ collapse: true });
  };

  const persistDraft = (makeActive = true) => {
    if (!draft || !draftAllocationComplete() || draftCount() < 1) return;
    const store = loadStore();
    const idx = store.groups.findIndex(group => group.id === draft.id);
    const clean = JSON.parse(JSON.stringify(draft));
    if (idx >= 0) store.groups[idx] = clean; else store.groups.push(clean);
    if (makeActive) store.activeId = clean.id;
    saveStore(store);
  };

  const refreshCartSectionsWithoutNativePopup = (result) => {
    if (!cartUI || typeof cartUI.renderContents !== 'function' || !result?.sections) return false;
    document.documentElement.classList.add('tda-suppress-native-cart');
    try {
      cartUI.renderContents(result);
      if (typeof cartUI.close === 'function') cartUI.close();
    } finally {
      window.setTimeout(() => {
        if (typeof cartUI.close === 'function') cartUI.close();
        document.documentElement.classList.remove('tda-suppress-native-cart');
      }, 120);
    }
    return true;
  };

  const addReservationsToBag = async ({ continueBrowsing = false, triggerButton = null } = {}) => {
    /* Keep the final CTA resilient. The review itself is the customer's confirmation,
       so a stale internal completeness flag must never make the button silently do nothing. */
    const actionButton = triggerButton || reservationView.querySelector('[data-tda-res-entry-continue]') || addBagButton;
    if (!draft || actionButton?.disabled) return;
    if (bookingCalendar) {
      if (!bookingCalendar.preview) {
        if (actionButton) actionButton.disabled = true;
        try {
          await refreshBookingCalendar();
        } catch {
          let notice = entry.querySelector('[data-tda-calendar-notice]');
          if (!notice) {notice=document.createElement('p');notice.dataset.tdaCalendarNotice='';notice.className='tda-res-date-note';notice.setAttribute('role','status');entry.appendChild(notice);}
          notice.textContent='Your selections are still here. Please try again to check availability.';
          return;
        } finally { if (actionButton) actionButton.disabled = false; }
      }
      const message = bookingCalendar.preview ? 'Preview only — no reservation will be added to your bag.' : calendarApi.validateSelection({...draft,items:Object.values(draft.items || {})},selectedSlot(),bookingCalendar);
      if (message) {
        let notice = entry.querySelector('[data-tda-calendar-notice]');
        if (!notice) { notice=document.createElement('p');notice.dataset.tdaCalendarNotice='';notice.className='tda-res-date-note';notice.setAttribute('role','status');entry.appendChild(notice); }
        notice.textContent=message;
        return;
      }
    }

    if (!draftAllocationComplete()) { showStep(1); return; }
    if (draftCount() < 1) { showStep(2); return; }

    /* A private weekly allocation already defines delivery. Repair that state defensively
       in case the customer arrived here from an older saved draft. */
    if (!bookingCalendar && draft.allocationType === 'private' && !draftDeliveryComplete()) {
      draft.deliveryMode = 'standard';
      draft.deliveryDate = '';
      draft.deliveryLabel = draft.deliveryWeek || 'Atelier allocation';
    }
    if (!draft.giftingReviewed) { showStep(2); openGifting(); return; }
    if ((bookingCalendar || draft.allocationType !== 'private') && !draftDeliveryComplete()) { showStep(3); return; }

    ensureSeedItem();

    const items = Object.values(draft.items || {})
      .filter(item => Number(item.quantity) > 0 && Number.isFinite(Number(item.variantId)) && Number(item.variantId) > 0)
      .map(item => {
        const properties = { 'Reservation allocation': allocationDisplay(draft) };
        if (bookingCalendar) properties['_TDA reservation slot'] = selectedSlot().id;
        if (item.image) properties['_TDA creation image'] = item.image;
        if (item.title) properties['_TDA creation'] = item.title;
        properties['_TDA gift configured'] = 'Yes';
        if (draft.gifting?.enabled) {
          properties['Gift presentation'] = 'Yes';
          if (draft.gifting.message) properties['Gift message'] = draft.gifting.message;
          if (draft.gifting.signature) properties['Gift signature'] = draft.gifting.signature;
          properties['Gift bag'] = draft.gifting.bag ? 'Yes' : 'No';
        }

        if (draft.deliveryWeek) properties['Atelier allocation'] = draft.deliveryWeek;
        if (draft.deliveryMode === 'standard' && draft.deliveryLabel) properties['Delivery preference'] = draft.deliveryLabel;
        if (draft.deliveryMode === 'date' && draft.deliveryDate) properties['Requested delivery date'] = draft.deliveryDate;
        return { id: Number(item.variantId), quantity: Number(item.quantity), properties };
      });

    if (!items.length) {
      if (errorBox) {
        errorBox.textContent = 'Please review your creation before adding it to your bag.';
        errorBox.hidden = false;
      }
      return;
    }

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    prepareBagButton(actionButton);
    const loadingStartedAt = performance.now();
    const minimumLoadingTime = 920;

    if (actionButton) {
      actionButton.disabled = true;
      actionButton.classList.add('is-loading');
      actionButton.classList.remove('is-turning');
      /* Restart the single Atelier turn on every add. */
      void actionButton.offsetWidth;
      actionButton.classList.add('is-turning');
      actionButton.setAttribute('aria-busy', 'true');
    }

    try {
      const sectionIds = cartUI?.getSectionsToRender?.().map(section => section.id).filter(Boolean) || [];
      const payload = { items };

      if (sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(cartAddEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });

      let result = {};
      try { result = await response.json(); } catch (_) {}

      if (!response.ok || result?.status) {
        throw new Error(result?.description || result?.message || `Unable to add reservation (${response.status})`);
      }

      const elapsed = performance.now() - loadingStartedAt;
      if (elapsed < minimumLoadingTime) {
        await new Promise(resolve => window.setTimeout(resolve, minimumLoadingTime - elapsed));
      }

      try { localStorage.removeItem(storageKey); } catch (_) {}

      if (actionButton) {
        actionButton.classList.remove('is-turning');
        actionButton.classList.remove('is-turning');
        actionButton.classList.remove('is-loading');
        actionButton.removeAttribute('aria-busy');
        actionButton.disabled = false;
        setBagButtonLabel('Added to bag', actionButton);
      }

      /* Mobile: lower the existing reservation window as one curtain before
         the TDA bag drawer appears. Desktop keeps its existing close behaviour. */
      const mobileCurtainClose = mobileFullReservation() && reservationJourneyActive();
      const bagOpenDelay = mobileCurtainClose ? mobileReservationCurtainDuration + 60 : 1320;

      if (mobileCurtainClose) {
        /* Match the site-wide drawer close: keep the parent transparent
           while the window lowers, and fade the dark scrim out at the same time. */
        drawer.classList.add('is-curtain-returning');
        drawer.classList.remove('is-curtain-dark');
        reservationView.classList.add('tda-reservation-curtain-motion');
        reservationView.classList.remove('is-curtain-open');
        window.setTimeout(
          resetReservationDrawerInstantlyForBag,
          mobileReservationCurtainDuration
        );
      } else {
        closeDrawer();
      }

      /* While the reservation curtain is closing, refresh the bespoke TDA bag.
         This updates both its contents and the header count even when the header
         was rendered with an empty bag and therefore had no count bubble. */
      let bagRefresh = Promise.resolve(null);
      if (window.TDAMiniCart && typeof window.TDAMiniCart.refresh === 'function') {
        bagRefresh = Promise.resolve(window.TDAMiniCart.refresh()).catch((err) => {
          console.warn('[TDA reservation] Bag refresh failed:', err);
          return null;
        });
      }

      /* The header owns the bag UI and count. Ask it to refresh immediately, then
         open only after the reservation curtain has finished its close motion. */
      document.dispatchEvent(new CustomEvent('tda:cart:refresh'));

      window.setTimeout(async () => {
        if (continueBrowsing) return;
        try { await bagRefresh; } catch (_) {}

        if (window.TDAMiniCart && typeof window.TDAMiniCart.open === 'function') {
          try {
            await window.TDAMiniCart.open();
            return;
          } catch (err) {
            console.warn('[TDA reservation] Direct bag open failed:', err);
          }
        }

        const tdaMiniCartTrigger = document.querySelector('[data-tda-mini-cart-trigger]');
        if (tdaMiniCartTrigger) {
          tdaMiniCartTrigger.click();
          return;
        }
        if (cartUI && typeof cartUI.open === 'function') cartUI.open();
      }, bagOpenDelay);

    } catch (error) {
      if (actionButton) {
        actionButton.classList.remove('is-loading');
        actionButton.removeAttribute('aria-busy');
        actionButton.disabled = false;
        setBagButtonLabel('Add to bag', actionButton);
      }
      if (errorBox) {
        errorBox.textContent = error?.message || 'This allocation is no longer available. Please review your reservation.';
        errorBox.hidden = false;
      }
      console.error('[TDA reservation] Add to bag failed:', error);
    }
  };

  const decorateDiscoverTopActions = () => {
    const head = discoverContent.querySelector('.tda-discover-view__head');
    const priceRow = discoverContent.querySelector('.tda-discover-view__price-row');
    const productNode = discoverContent.querySelector('[data-tda-discover-product]');
    if (!head || !priceRow || !productNode || head.querySelector('.tda-discover-top-actions')) return;
    const actions = document.createElement('div');
    actions.className = 'tda-discover-top-actions';
    const explore = document.createElement('a');
    explore.className = 'tda-discover-view-link';
    explore.href = productNode.dataset.productUrl || '#';
    explore.setAttribute('aria-label','View Creation');
    explore.textContent = 'View Creation';
    actions.append(explore);
    priceRow.insertAdjacentElement('afterend', actions);
    const oldExplore = discoverContent.querySelector('.tda-discover-view__explore');
    if (oldExplore) oldExplore.remove();
  };

  /* Discover accordions — one chapter at a time.
     Use an explicit height transition rather than the browser's native
     <details> snap so opening and closing remain slow, continuous and visible. */
  const accordionMotions = new WeakMap();
  const accordionOpenDuration = 380;
  const accordionCloseDuration = 340;
  const accordionEasing = 'cubic-bezier(.22,.61,.36,1)';
  const reservationFaqMotion = details => ({
    duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 640,
    easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
  });

  const clearAccordionMotion = (details, preserveCurrent = false) => {
    const state = accordionMotions.get(details);
    if (!state) return;
    window.clearTimeout(state.timer);
    accordionMotions.delete(details);

    const body = state.body;
    if (!body) return;

    if (preserveCurrent) {
      const rect = body.getBoundingClientRect();
      const styles = window.getComputedStyle(body);
      body.style.transition = 'none';
      body.style.height = `${Math.max(0, rect.height)}px`;
      body.style.opacity = styles.opacity;
      body.style.transform = styles.transform === 'none' ? 'translateY(0)' : styles.transform;
      void body.offsetHeight;
    } else {
      body.style.transition = '';
    }
  };

  const settleAccordion = (details, body, shouldRemainOpen) => {
    accordionMotions.delete(details);
    details.classList.remove('is-opening', 'is-closing', 'is-animating');

    if (!shouldRemainOpen) details.open = false;

    body.style.transition = '';
    body.style.overflow = '';
    body.style.height = '';
    body.style.opacity = '';
    body.style.transform = '';

    const summary = details.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', shouldRemainOpen ? 'true' : 'false');
  };

  const openDiscoverAccordion = (details) => {
    if (!details) return;
    const body = details.querySelector('.tda-discover-accordion__body');
    if (!body) {
      details.open = true;
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
      return;
    }

    if (details.open && !details.classList.contains('is-closing')) return;

    const faqMotion = details.closest('.tda-reservation-guide__faqs') ? reservationFaqMotion(details) : null;
    const duration = faqMotion ? faqMotion.duration : accordionOpenDuration;
    const easing = faqMotion ? faqMotion.easing : accordionEasing;
    clearAccordionMotion(details, true);
    details.classList.remove('is-closing');
    details.classList.add('is-opening', 'is-animating');

    details.open = true;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');

    body.style.transition = 'none';
    body.style.overflow = 'hidden';
    body.style.height = '0px';
    body.style.opacity = '1';
    body.style.transform = 'none';
    void body.offsetHeight;

    const targetHeight = body.scrollHeight;

    requestAnimationFrame(() => {
      body.style.transition = `height ${duration}ms ${easing}`;
      body.style.height = `${targetHeight}px`;
    });

    const timer = window.setTimeout(
      () => settleAccordion(details, body, true),
      duration + 70
    );
    accordionMotions.set(details, { timer, body });
  };

  const closeDiscoverAccordion = (details) => {
    if (!details || !details.open) return;
    const body = details.querySelector('.tda-discover-accordion__body');
    if (!body) {
      details.open = false;
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      return;
    }

    const faqMotion = details.closest('.tda-reservation-guide__faqs') ? reservationFaqMotion(details) : null;
    const duration = faqMotion ? faqMotion.duration : accordionCloseDuration;
    const easing = faqMotion ? faqMotion.easing : accordionEasing;
    clearAccordionMotion(details, true);

    const currentHeight = Math.max(body.getBoundingClientRect().height, 0);
    body.style.transition = 'none';
    body.style.overflow = 'hidden';
    body.style.height = `${currentHeight || body.scrollHeight}px`;
    body.style.opacity = '1';
    body.style.transform = 'none';

    details.classList.remove('is-opening');
    details.classList.add('is-closing', 'is-animating');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    void body.offsetHeight;

    requestAnimationFrame(() => {
      body.style.transition = `height ${duration}ms ${easing}`;
      body.style.height = '0px';
    });

    const timer = window.setTimeout(
      () => settleAccordion(details, body, false),
      duration + 70
    );
    accordionMotions.set(details, { timer, body });
  };

  const toggleDiscoverAccordion = (details) => {
    if (!details) return;
    if (details.closest('.tda-reservation-guide__faqs') && details.classList.contains('is-animating')) return;

    if (details.open && !details.classList.contains('is-closing')) {
      closeDiscoverAccordion(details);
      return;
    }

    const group = details.closest('.tda-discover-view__accordions');
    const others = [...(group?.querySelectorAll('.tda-discover-accordion[open]') || [])]
      .filter(other => other !== details);

    others.forEach(closeDiscoverAccordion);

    window.setTimeout(() => openDiscoverAccordion(details), others.length ? 120 : 0);
  };

  const populateDiscover = (productId) => {
    const template = root.querySelector(`[data-tda-discover-template="${CSS.escape(String(productId))}"]`);
    if (!template) return false;
    discoverContent.innerHTML = '';
    discoverContent.appendChild(template.content.cloneNode(true));
    currentProduct = productById.get(String(productId)) || null;
    decorateDiscoverTopActions();

    /* Discover is deliberately product-only. It never reflects a previous
       reservation or tries to sell into an existing allocation. */
    const primary = discoverContent.querySelector('[data-tda-new-reserve-start]');
    const primaryLabel = discoverContent.querySelector('[data-tda-new-reserve-label]');
    discoverContent.querySelectorAll('.tda-discover-context-note,[data-tda-inline-active-add]').forEach(node => node.remove());

    if (primary) {
      primary.hidden = false;
      primary.disabled = false;
      delete primary.dataset.activeGroupId;
      delete primary.dataset.tdaInlineActive;
    }
    if (primaryLabel && !primaryLabel.textContent.trim()) primaryLabel.textContent = 'Begin selection';
    return true;
  };

  let reservationMotionTimer = null;
  const mobileReservationCurtainDuration = 920;

  const openMobileReservationCurtain = () => {
    if (!mobileFullReservation()) return false;

    /* Match the site-wide menu / shopping-bag behaviour:
       darken the page while the reservation curtain rises. */
    drawer.classList.add('is-curtain-opening', 'is-curtain-dark');
    reservationView.classList.add('tda-reservation-curtain-motion');
    reservationView.classList.remove('is-curtain-open');

    /* Force the off-screen starting position to paint before the rise. */
    void reservationView.offsetHeight;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        reservationView.classList.add('is-curtain-open');
      });
    });

    window.setTimeout(() => {
      drawer.classList.remove('is-curtain-opening');
    }, mobileReservationCurtainDuration);

    return true;
  };

  const resetReservationDrawerInstantlyForBag = () => {
    drawer.classList.remove(
      'is-open',
      'is-closing',
      'is-expanded',
      'is-reservation-drawer',
      'is-expanding-reservation',
      'is-collapsing-reservation',
      'is-curtain-returning',
      'is-curtain-opening',
      'is-curtain-dark'
    );
    drawer.setAttribute('aria-hidden', 'true');
    reservationView.hidden = true;
    reservationView.setAttribute('aria-hidden', 'true');
    reservationView.classList.remove(
      'is-active',
      'is-curtain-open',
      'tda-reservation-curtain-motion'
    );
    discoverView.hidden = false;
    document.documentElement.style.overflow = '';
  };

  const setReservationDrawerMode = () => {
    window.clearTimeout(reservationMotionTimer);
    drawer.classList.remove('is-expanded', 'is-expanding-reservation', 'is-collapsing-reservation');
    drawer.classList.add('is-reservation-drawer');
  };

  const expandReservationExperience = () => {
    if (drawer.classList.contains('is-expanded') && !drawer.classList.contains('is-collapsing-reservation')) return;
    window.clearTimeout(reservationMotionTimer);
    drawer.classList.remove('is-reservation-drawer', 'is-collapsing-reservation');
    drawer.classList.add('is-expanding-reservation');
    requestAnimationFrame(() => {
      drawer.classList.add('is-expanded');
      reservationMotionTimer = window.setTimeout(() => {
        drawer.classList.remove('is-expanding-reservation');
      }, 1260);
    });
  };

  const collapseReservationExperience = () => {
    window.clearTimeout(reservationMotionTimer);
    if (drawer.classList.contains('is-reservation-drawer') && !drawer.classList.contains('is-expanded')) return;

    /* Reverse the exact expansion rather than snapping straight back to the
       drawer class. Removing is-expanded contracts the outer curtain while
       is-collapsing-reservation gives the inner white sheet its drawer target. */
    drawer.classList.remove('is-expanding-reservation', 'is-reservation-drawer');
    drawer.classList.add('is-collapsing-reservation');
    requestAnimationFrame(() => drawer.classList.remove('is-expanded'));

    reservationMotionTimer = window.setTimeout(() => {
      drawer.classList.remove('is-collapsing-reservation');
      drawer.classList.add('is-reservation-drawer');
    }, 1260);
  };

  const openDrawer = (trigger) => {
    const productId = trigger?.dataset?.productId;
    if (!productId || !populateDiscover(productId)) return;
    lastTrigger = trigger;
    window.clearTimeout(closeTimer);
    drawer.classList.remove('is-closing','is-expanded','is-reservation-drawer','is-expanding-reservation','is-collapsing-reservation');
    reservationView.hidden = true;
    reservationView.setAttribute('aria-hidden','true');
    reservationView.classList.remove('is-active', 'is-curtain-open', 'tda-reservation-curtain-motion');
    discoverView.hidden = false;
    drawer.setAttribute('aria-hidden','false');
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(() => panel.focus({preventScroll:true}), 220);
  };

  const hideLeaveConfirm = ({ restoreFocus = true } = {}) => {
    if (!leaveConfirm || leaveConfirm.hidden) return;
    leaveConfirm.classList.remove('is-visible');
    leaveConfirm.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      leaveConfirm.hidden = true;
      if (restoreFocus) drawer.querySelector('.tda-discover-curtain__close')?.focus({ preventScroll: true });
    }, 280);
  };

  const showLeaveConfirm = () => {
    if (!leaveConfirm || drawer.getAttribute('aria-hidden') === 'true') return;
    leaveConfirm.hidden = false;
    leaveConfirm.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => leaveConfirm.classList.add('is-visible'));
    window.setTimeout(() => leaveReservationButton?.focus({ preventScroll: true }), 80);
  };

  const reservationJourneyActive = () => (
    !reservationView.hidden &&
    reservationView.getAttribute('aria-hidden') === 'false' &&
    reservationView.classList.contains('is-active')
  );

  const closeDrawer = () => {
    if (drawer.getAttribute('aria-hidden') === 'true' || drawer.classList.contains('is-closing')) return;
    if (mobileFullReservation() && reservationJourneyActive()) {
      hideLeaveConfirm({ restoreFocus: false });
      window.clearTimeout(reservationMotionTimer);
      drawer.classList.add('is-closing', 'is-curtain-returning');
      drawer.classList.remove('is-curtain-dark');
      reservationView.classList.add('tda-reservation-curtain-motion');
      reservationView.classList.remove('is-curtain-open');
      const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : mobileReservationCurtainDuration;
      closeTimer = window.setTimeout(() => {
        resetReservationDrawerInstantlyForBag();
        if (lastTrigger) lastTrigger.focus({ preventScroll: true });
      }, duration);
      return;
    }
    if (leaveConfirm && !leaveConfirm.hidden) {
      leaveConfirm.classList.remove('is-visible');
      leaveConfirm.setAttribute('aria-hidden', 'true');
      leaveConfirm.hidden = true;
    }
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    document.documentElement.style.overflow = '';
    closeTimer = window.setTimeout(() => {
      drawer.classList.remove('is-closing','is-expanded','is-reservation-drawer','is-expanding-reservation','is-collapsing-reservation');
      drawer.setAttribute('aria-hidden','true');
      reservationView.hidden = true;
      reservationView.setAttribute('aria-hidden','true');
      reservationView.classList.remove('is-active', 'is-curtain-open', 'tda-reservation-curtain-motion');
      discoverView.hidden = false;
      if (lastTrigger) lastTrigger.focus({preventScroll:true});
    }, 1260);
  };

  const requestCloseDrawer = () => {
    if (leaveConfirm && !leaveConfirm.hidden) {
      hideLeaveConfirm();
      return;
    }
    if (reservationJourneyActive()) {
      showLeaveConfirm();
      return;
    }
    closeDrawer();
  };

  leaveReservationButton?.addEventListener('click', () => {
    hideLeaveConfirm({ restoreFocus: false });
    draft = null;
    currentStep = 0;
    isNewAllocationRoute = false;
    closeDrawer();
  });

  continueReservationButton?.addEventListener('click', () => {
    hideLeaveConfirm();
  });

  leaveConfirm?.addEventListener('click', (event) => {
    if (event.target === leaveConfirm) hideLeaveConfirm();
  });

  const expandToReservation = () => {
    if (!currentProduct) return;
    isNewAllocationRoute = true;
    draft = createDraft(currentProduct);

    if (mobileFullReservation()) {
      window.clearTimeout(reservationMotionTimer);
      drawer.classList.remove('is-reservation-drawer', 'is-expanding-reservation', 'is-collapsing-reservation');
      drawer.classList.add('is-expanded');

      reservationView.hidden = false;
      reservationView.setAttribute('aria-hidden','false');
      reservationView.classList.add('is-active');
      showEntry();

      /* Keep the existing Discover view underneath while the reservation
         window rises over it like a curtain. Hide it only once covered. */
      openMobileReservationCurtain();
      reservationMotionTimer = window.setTimeout(() => {
        discoverView.hidden = true;
      }, mobileReservationCurtainDuration);
      return;
    }

    setReservationDrawerMode();
    reservationView.hidden = false;
    reservationView.setAttribute('aria-hidden','false');
    window.setTimeout(() => {
      discoverView.hidden = true;
      reservationView.classList.add('is-active');
      showEntry();
    }, 300);
  };

  const openDirectReservation = (productId, trigger = null) => {
    const product = productById.get(String(productId || '')) || (products.length === 1 ? products[0] : null);
    if (!product) return false;

    /* Direct Reserve now begins with the same calm right-hand drawer used by
       All Creations. The guide lives in the product reservation root's
       Discover view. Its Begin Reservation button then calls
       expandToReservation(), so desktop and mobile inherit the exact same
       reservation transition and geometry as Discover -> Reserve. */
    currentProduct = product;
    lastTrigger = trigger || document.activeElement || null;
    draft = null;
    currentStep = 0;
    isNewAllocationRoute = false;

    window.clearTimeout(closeTimer);
    window.clearTimeout(reservationMotionTimer);
    drawer.classList.remove(
      'is-closing',
      'is-expanded',
      'is-reservation-drawer',
      'is-expanding-reservation',
      'is-collapsing-reservation',
      'is-curtain-returning',
      'is-curtain-opening',
      'is-curtain-dark'
    );

    reservationView.hidden = true;
    reservationView.setAttribute('aria-hidden', 'true');
    reservationView.classList.remove('is-active', 'is-curtain-open', 'tda-reservation-curtain-motion');
    discoverView.hidden = false;

    /* Reopen the information drawer from a clean first view, matching the
       freshly-cloned Discover drawer on All Creations. */
    discoverContent.scrollTop = 0;
    discoverContent.querySelectorAll('.tda-discover-accordion').forEach(details => {
      clearAccordionMotion(details);
      details.open = false;
      details.classList.remove('is-opening', 'is-closing', 'is-animating');
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      const body = details.querySelector('.tda-discover-accordion__body');
      if (body) {
        body.style.transition = '';
        body.style.overflow = '';
        body.style.height = '';
        body.style.opacity = '';
        body.style.transform = '';
      }
    });

    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(() => panel.focus({ preventScroll: true }), 220);
    return true;
  };

  const reservationApi = window.TDAReservation = window.TDAReservation || {};
  reservationApi.instances = Array.isArray(reservationApi.instances) ? reservationApi.instances : [];
  const defaultProductId = root.dataset.productId || products[0]?.id || '';
  const instanceApi = {
    root,
    hasProduct: (productId) => productById.has(String(productId || '')),
    open: (productId, trigger = null) => openDirectReservation(productId || defaultProductId, trigger),
    close: () => closeDrawer()
  };
  reservationApi.instances.push(instanceApi);
  reservationApi.open = (productId, trigger = null) => {
    const instances = reservationApi.instances || [];
    const match = instances.find(instance => instance.hasProduct?.(productId)) || (instances.length === 1 ? instances[0] : null);
    return match ? match.open(productId, trigger) : false;
  };
  reservationApi.openForProduct = (context = {}) => reservationApi.open(context.productId || context.id, context.returnFocus || context.trigger || null);
  reservationApi.close = () => {
    const openInstance = (reservationApi.instances || []).find(instance => instance.root?.querySelector?.('[data-tda-discover-curtain]')?.getAttribute('aria-hidden') === 'false');
    openInstance?.close?.();
  };

  openers.forEach(opener => {
    opener.addEventListener('click', event => {
      event.preventDefault(); event.stopPropagation();
      openDrawer(opener);
    });
  });
  closers.forEach(closer => closer.addEventListener('click', event => { event.preventDefault(); requestCloseDrawer(); }));

  discoverContent.addEventListener('click', event => {
    const accordionSummary = event.target.closest('.tda-discover-accordion > summary');
    if (accordionSummary) {
      event.preventDefault();
      toggleDiscoverAccordion(accordionSummary.parentElement);
      return;
    }

    const pricing = event.target.closest('[data-tda-drawer-pricing]');
    const contact = event.target.closest('[data-tda-drawer-contact]');
    const reserve = event.target.closest('[data-tda-new-reserve-start]');
    if (pricing) {
      const info = root.querySelector('.tda-creation-card__info');
      info?.click();
      return;
    }
    if (contact) {
      const contactTrigger = document.querySelector('[data-tda-contact-trigger]');
      closeDrawer();
      window.setTimeout(() => contactTrigger?.click(), 1280);
      return;
    }
    if (reserve && !reserve.disabled) {
      expandToReservation();
      return;
    }
  });

  panel.addEventListener('click', event => {
    if (waitlist && !waitlist.hidden && waitlist.classList.contains('is-open')) {
      if (!waitlist.contains(event.target) &&
          !event.target.closest('button, a, input, select, textarea, label, summary, [role="button"], [role="link"]')) {
        closeWaitlistInline();
      }
    }

    if (addMoreOpen) {
      /* Keep the additional-creations drawer open while quantities are adjusted
         anywhere in Step 2, including the primary creation row. Only a true
         outside click should close it. */
      const quantityControl = event.target.closest('[data-tda-res-qty-minus], [data-tda-res-qty-plus]');
      if (!event.target.closest('.tda-res-add-more') && !quantityControl) closeAddMoreInline();
    }
  });

  reservationView.addEventListener('click', event => {
    if (event.target.closest('[data-tda-res-gift-edit]')) { openGifting(); return; }
    if (event.target.closest('[data-tda-res-gift-cancel]')) {
      draft.gifting = {enabled:!!(giftMessage.value.trim() || giftSignature.value.trim() || giftBag.checked),message:giftMessage.value.trim().slice(0,200),signature:giftSignature.value.trim().slice(0,20),bag:giftBag.checked};
      showStep(2); return;
    }
    if (event.target.closest('[data-tda-res-gift-save]')) {
      if (!draft) return;
      draft.gifting = {enabled:!!(giftMessage.value.trim() || giftSignature.value.trim() || giftBag.checked),message:giftMessage.value.trim().slice(0,200),signature:giftSignature.value.trim().slice(0,20),bag:giftBag.checked};
      setGiftingView(false, false);
      draft.giftingReviewed = true;
      updateEntry();
      if (draft.allocationType === 'private' && !bookingCalendar) showEntry({ collapse:true });
      else showStep(3);
      return;
    }

    if (event.target.closest('[data-tda-calendar-retry]')) { renderAllocations(); return; }
    const calendarWaitlist = event.target.closest('[data-tda-calendar-waitlist]');
    if (bookingCalendar && calendarWaitlist) {
      const slot = bookingCalendar.slots.find(item => item.id === calendarWaitlist.dataset.tdaSlotId);
      if (slot) openWaitlist(slot.allocationName, 'full', calendarWaitlist);
      return;
    }
    const entryOpen = event.target.closest('[data-tda-res-entry-open]');
    const entryContinue = event.target.closest('[data-tda-res-entry-continue]');
    const nextAllocationWaitlist = event.target.closest('[data-tda-res-next-allocation-waitlist]');
    const allocation = event.target.closest('[data-tda-res-allocation]');
    const privateRegister = event.target.closest('[data-tda-private-register]');
    const waitlistBack = event.target.closest('[data-tda-res-waitlist-back]');
    const next = event.target.closest('[data-tda-res-next]');
    const back = event.target.closest('[data-tda-res-back]');
    const minus = event.target.closest('[data-tda-res-qty-minus]');
    const plus = event.target.closest('[data-tda-res-qty-plus]');
    const edit = event.target.closest('[data-tda-res-edit-step]');
    const save = event.target.closest('[data-tda-res-save]');
    const addBag = event.target.closest('[data-tda-res-add-bag]');
    const deliveryModeButton = event.target.closest('[data-tda-res-delivery-mode]');
    const deliveryComplete = event.target.closest('[data-tda-res-delivery-complete]');
    const addMoreToggle = event.target.closest('[data-tda-res-add-more-toggle]');

    /* Quantity controls belong to the same Step 2 editing session even when
       they sit in the primary creation row. Do not collapse the open additional
       creations drawer when the customer adjusts the main creation quantity. */
    const quantityControl = event.target.closest('[data-tda-res-qty-minus], [data-tda-res-qty-plus]');
    if (addMoreOpen && !event.target.closest('.tda-res-add-more') && !quantityControl) closeAddMoreInline();

    if (addMoreToggle) {
      if (addMoreOpen) closeAddMoreInline();
      else openAddMoreInline();
      return;
    }
    if (entryOpen && !entryOpen.disabled) {
      const entryStep = Number(entryOpen.dataset.tdaResEntryOpen);
      expandReservationExperience();
      if (entryStep === 3 && draft?.allocationType === 'private' && !bookingCalendar) { showStep(1); return; }
      showStep(entryStep);
      if (entryStep === 2) openGifting();
      return;
    }
    if (entryContinue) {
      if (draftComplete()) { addReservationsToBag({ continueBrowsing:false, triggerButton: entryContinue }); return; }
      if (!draftAllocationComplete()) {
        expandReservationExperience();
        showStep(1);
        return;
      }
      if (draftCount() < 1) { expandReservationExperience(); showStep(2); return; }
      if (!draft.giftingReviewed) { expandReservationExperience(); showStep(2); openGifting(); return; }
      if (draft?.allocationType === 'private' && !bookingCalendar) { showEntry({ collapse: true }); return; }
      expandReservationExperience();
      showStep(3); return;
    }
    if (privateRegister) {
      const view = ensurePrivateAvailabilityView();
      if (!view || !waitlist) return;
      prepareWaitlistMicroFields();
      parkWaitlist();
      anchorStep1ForInlineDrawer();
      waitlist.classList.remove('is-open');
      waitlist.hidden = false;
      waitlist.classList.add('is-inline-drawer', 'tda-res-inline-drawer');
      waitlist.setAttribute('aria-hidden','false');
      if (waitlistCopy) waitlistCopy.textContent = 'Be among the first to know when the next private allocation opens.';
      if (waitlistTags) waitlistTags.value = `newsletter,tda-waitlist,tda-box-${slugify(currentProduct?.title)},tda-allocation-private-occasions`;
      privateRegister.insertAdjacentElement('afterend', waitlist);
      void waitlist.offsetHeight;
      requestAnimationFrame(() => requestAnimationFrame(() => waitlist.classList.add('is-open')));
      return;
    }
    if (nextAllocationWaitlist) {
      if (activeWaitlistTrigger === nextAllocationWaitlist && waitlist?.classList.contains('is-open')) {
        closeWaitlistInline();
        return;
      }
      const name = nextAllocationWaitlist.dataset.tdaResNextEdition || '';
      const windowName = nextAllocationWaitlist.dataset.tdaResNextWindow || '';
      const optionButton = nextAllocationWaitlist.closest('.tda-res-allocation-option-wrap')?.querySelector('.tda-res-allocation-option') || null;
      openWaitlist(name, 'upcoming', optionButton, windowName, nextAllocationWaitlist);
      return;
    }
    if (allocation) {
      if (bookingCalendar) {
        if (allocation.dataset.tdaResAllocationType === 'private') {
          const slot = calendarApi.availableSlots(bookingCalendar).filter(item=>item.kind==='private' && calendarApi.remaining(item)>0).sort((a,b)=>calendarApi.remaining(b)-calendarApi.remaining(a))[0];
          if (slot) selectCalendarSlot(slot);
        } else {
          const slot = bookingCalendar.slots.find(item=>item.id === allocation.dataset.tdaSlotId);
          if (slot && calendarApi.slotState(slot,bookingCalendar)==='available') selectCalendarSlot(slot);
          else if (slot) openWaitlist(slot.allocationName,'full',allocation);
        }
        return;
      }
      const selectable = allocation.dataset.tdaResSelectable === 'true';
      const name = allocation.dataset.tdaResAllocation || '';
      const label = allocation.dataset.tdaResAllocationLabel || name;
      const windowName = allocation.dataset.tdaResWindowName || '';
      const type = allocation.dataset.tdaResAllocationType || 'seasonal';
      if (type === 'private') {
        const option = nearestPrivateAllocation(currentProduct);
        /* Private occasions never open the release waitlist. If the whole
           rolling eight-week horizon is full, the row simply remains closed. */
        if (!selectable || !option) return;
        selectPrivateAllocation(option, { render:false });
        renderAllocations();
        return;
      }
      if (!selectable) { openWaitlist(name, allocation.dataset.tdaResWaitlistReason || 'full', allocation, windowName); return; }
      setAllocation(name,type,label,windowName);
      return;
    }
    if (deliveryModeButton) {
      if (!draft) return;
      const mode = deliveryModeButton.dataset.tdaResDeliveryMode || 'standard';
      const rules = deliveryRules();
      if(mode==='standard') reservationView.querySelector('[data-tda-date-picker]')?.dispatchEvent(new Event('tda-picker-reset'));
      draft.deliveryMode = mode;
      if(bookingCalendar && draft.allocationType==='private' && mode==='standard') usePrivateDeliverySlot(calendarApi.earliestPrivateSlot(bookingCalendar,Math.max(1,draftCount())));
      if (mode === 'standard') {
        draft.deliveryDate = '';
        draft.deliveryLabel = rules.summaryLabel;
      } else {
        draft.deliveryLabel = draft.deliveryDate ? formatHumanDate(draft.deliveryDate) : '';
      }
      syncDeliveryControls();
      if(bookingCalendar && mode==='date')deliveryPicker?.open();
      updateEntry();
      return;
    }
    if (deliveryComplete) { completeDelivery(); return; }
    if (waitlistBack) { renderAllocations(); return; }
    if (next) {
      const targetStep = Number(next.dataset.tdaResNext);
      if (targetStep === 3) {
        if (!draftAllocationComplete() || draftCount() < 1) return;
        closeAddMoreInline();
        openGifting();
        return;
      }
      /* Private occasions resolve their nearest weekly allocation directly in
         Step 1. Continue therefore goes straight to quantities, with no extra
         availability window. */
      if (targetStep === 2 && draft?.allocationType === 'private') {
        if (!draftAllocationComplete()) { renderAllocations(); return; }
        showStep(2);
        return;
      }
      /* Weekly private allocations already determine delivery, so they never enter the choose-a-date step. */
      if (targetStep === 3 && draft?.allocationType === 'private' && !bookingCalendar) {
        showEntry({ collapse: true });
        return;
      }
      showStep(targetStep);
      return;
    }
    if (back) {
      if (back.dataset.tdaResBack === 'entry') {
        showEntry({ collapse: true });
      } else {
        const fromDelivery = currentStep === 3 && back.dataset.tdaResBack === '2';
        showStep(Number(back.dataset.tdaResBack));
        if (fromDelivery) openGifting();
      }
      return;
    }
    if (minus) { changeQuantity(minus.dataset.tdaResQtyMinus, -1); return; }
    if (plus) { changeQuantity(plus.dataset.tdaResQtyPlus, 1); return; }
    if (edit) {
      const editStep = Number(edit.dataset.tdaResEditStep);
      if (editStep === 3 && draft?.allocationType === 'private' && !bookingCalendar) { showStep(1); return; }
      showStep(editStep);
      return;
    }
    if (save) { addReservationsToBag({ continueBrowsing:true, triggerButton: save }); return; }
    if (addBag) { addReservationsToBag({ continueBrowsing:false, triggerButton: addBag }); }
  });

  // Outside taps dismiss the calendar without changing the delivery preference or date.
  document.addEventListener('click', event => {
    if(currentStep!==3 || !deliveryCalendarOpen || !drawer.classList.contains('is-open'))return;
    if(event.composedPath().some(node=>node.matches?.('[data-tda-res-delivery-date-drawer], [data-tda-res-delivery-mode="date"]')))return;
    deliveryPicker?.close();
  });

  reservationView.addEventListener('focusin', event => {
    if (event.target.matches('[data-tda-res-delivery-date]')) syncDeliveryDateField();
  });
  reservationView.addEventListener('input', event => {
    const input = event.target.closest('[data-tda-res-delivery-date]');
    if (!input || !draft) return;
    draft.deliveryDate = input.value || '';
    draft.deliveryLabel = draft.deliveryDate ? formatHumanDate(draft.deliveryDate) : '';
    syncDeliveryControls();
    updateEntry();
  });
  reservationView.addEventListener('change', event => {
    if (bookingCalendar && event.target.matches('[data-tda-private-week-select]')) {
      const slot = bookingCalendar.slots.find(item=>item.id === event.target.value);
      if (slot) selectCalendarSlot(slot);
      return;
    }
    const input = event.target.closest('[data-tda-res-delivery-date]');
    if (!input || !draft) return;
    draft.deliveryDate = input.value || '';
    draft.deliveryLabel = draft.deliveryDate ? formatHumanDate(draft.deliveryDate) : '';
    syncDeliveryControls();
    updateEntry();
  });
  reservationView.addEventListener('focusout', event => {
    if (event.target.matches('[data-tda-res-delivery-date]')) syncDeliveryDateField();
  });

  if (activePill) activePill.hidden = true;

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      if (leaveConfirm && !leaveConfirm.hidden) hideLeaveConfirm();
      else requestCloseDrawer();
    }
  });

  updateActivePill();
  };

  if (!window.__tdaReservationReserveBridgeBound) {
    window.__tdaReservationReserveBridgeBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-tda-global-reserve], [data-tda-reserve-launch]');
      if (!trigger) return;
      const productId = trigger.dataset.productId || trigger.closest('[data-tda-luxury-purchase]')?.dataset.productId || document.querySelector('[data-tda-product-reservation-root]')?.dataset.productId;
      if (!productId || !window.TDAReservation || typeof window.TDAReservation.open !== 'function') return;
      if (window.TDAReservation.open(productId, trigger)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  const boot = () => document.querySelectorAll('.tda-all-creations[data-tda-discover-v42]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
})();
